{
  "preview": {
    "tabs": {
      "patient": "Patient Report",
      "clinician": "Clinician Report"
    }
  },
  "common": {
    "loading": "Loading...",
    "error": "An error occurred",
    "save": "Save",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "submit": "Submit",
    "search": "Search",
    "filter": "Filter",
    "export": "Export",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "close": "Close",
    "yes": "Yes",
    "no": "No",
    "skip": "Skip",
    "continue": "Continue",
    "print": "Print",
    "download": "Download",
    "language": "Language",
    "saving": "Saving...",
    "previous": "Previous",
    "retry": "Retry",
    "clear": "Clear",
    "actions": "Actions",
    "showing": "Showing",
    "of": "of",
    "noData": "No data available",
    "required": "Required",
    "optional": "Optional",
    "active": "Active",
    "inactive": "Inactive",
    "viewAll": "View all",
    "apply": "Apply",
    "deleting": "Deleting...",
    "saved": "Saved",
    "add": "Add",
    "remove": "Remove",
    "dismiss": "Dismiss"
  },
  "nav": {
    "dashboard": "Dashboard",
    "patients": "Patients",
    "assessments": "Assessments",
    "reports": "Reports",
    "settings": "Settings",
    "help": "Help",
    "analytics": "Analytics",
    "clinicSettings": "Clinic Settings",
    "auditLog": "Audit Log",
    "gdpr": "GDPR / Data",
    "editProfile": "Edit Profile",
    "myProfile": "My Profile",
    "noTitle": "(none)",
    "title": "Title",
    "frontdesk": "Front Desk",
    "exercises": "Exercises",
    "conditions": "Conditions",
    "superadmin": "SuperAdmin",
    "kpi": "KPI Portal",
    "referralGaps": "Referral gaps",
    "staffBoard": "Staff board"
  },
  "auth": {
    "signIn": "Sign in",
    "signOut": "Sign out",
    "email": "Email",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "emailPasswordRequired": "Email and password are required",
    "appTitle": "MSK Insight",
    "appSubtitle": "Clinical Decision Support Platform",
    "signInSubtitle": "Sign in to your account",
    "emailLabel": "Email address",
    "emailPlaceholder": "you@clinic.com",
    "passwordPlaceholder": "Enter your password",
    "signingIn": "Signing in…",
    "loginFailed": "Login failed",
    "footer": "Evidence-based musculoskeletal care · GDPR compliant"
  },
  "dashboard": {
    "greeting": {
      "morning": "Good morning",
      "afternoon": "Good afternoon",
      "evening": "Good evening"
    },
    "newPatient": "New Patient",
    "newAssessment": "New Assessment",
    "viewAllPatients": "View All Patients",
    "totalPatients": "Total Patients",
    "thisMonth": "This Month",
    "assessments": "assessments",
    "pendingReviews": "Pending Reviews",
    "activeCare": "Active Care",
    "allTime": "All Time",
    "avgWellness": "BPS Score",
    "completion": "Completion",
    "assessmentsPerMonth": "Assessments Per Month",
    "noDataYet": "No data yet",
    "topConditions": "Top Conditions Diagnosed",
    "noDiagnoses": "No diagnoses yet",
    "bodyRegionDistribution": "Body Region Distribution",
    "noRegionData": "No region data yet",
    "fullAnalytics": "Full Analytics",
    "needsCompletion": "Needs Completion",
    "allCaughtUp": "All caught up! No assessments awaiting completion.",
    "saved": "Saved ",
    "awaitingFrontDesk": "Awaiting Front Desk",
    "frontDeskWorking": "Front Desk Working",
    "inProgress": "In Progress",
    "complete": "Complete",
    "recentPatients": "Recent Patients",
    "recentAssessments": "Recent Assessments",
    "noPatients": "No patients yet",
    "addFirstPatientMsg": "Add your first patient to get started.",
    "addFirstPatient": "Add First Patient",
    "noVisits": "No visits",
    "table": {
      "patient": "Patient",
      "age": "Age",
      "carePhase": "Care Phase",
      "lastVisit": "Last Visit",
      "clinician": "Clinician",
      "status": "Status",
      "date": "Date"
    },
    "stable": "stable",
    "onTrack": "on track",
    "last6Months": "Last 6 months"
  },
  "patient": {
    "new": "New Patient",
    "search": "Search patients",
    "firstName": "First name",
    "lastName": "Last name",
    "dateOfBirth": "Date of birth",
    "phone": "Phone",
    "email": "Email",
    "carePhase": "Care phase"
  },
  "patients": {
    "title": "Patients",
    "newPatient": "+ New Patient",
    "searchPlaceholder": "Search by name, MRN, phone...",
    "allPhases": "All Phases",
    "initial": "Initial",
    "activeCare": "Active Care",
    "maintenance": "Maintenance",
    "wellness": "Wellness",
    "noFound": "No patients found",
    "table": {
      "name": "Name",
      "mrn": "MRN",
      "dob": "DOB",
      "phone": "Phone",
      "carePhase": "Care Phase",
      "lastUpdated": "Last Updated"
    },
    "guardian": "Guardian",
    "total": "patients",
    "firstName": "First Name",
    "lastName": "Last Name",
    "status": {
      "active": "Active",
      "doNotContact": "Do Not Contact"
    },
    "typeahead": {
      "loading": "Searching…",
      "empty": "No matching patients",
      "error": "Search is unavailable right now",
      "lastSeen": "Last",
      "nextSeen": "Next",
      "lastAppt": "Last Appt:",
      "nextAppt": "Next Appt:"
    },
    "loadError": {
      "title": "Couldn't load patients.",
      "body": "Something went wrong on our side. Please try again in a moment.",
      "unavailable": "Patient data is temporarily unavailable. Please try again shortly.",
      "retry": "Retry"
    }
  },
  "patientDetail": {
    "backToPatients": "Back to patients",
    "startAssessment": "Start Assessment",
    "patientInfo": "Patient Information",
    "dateOfBirth": "Date of Birth",
    "gender": "Gender",
    "phone": "Phone",
    "email": "Email",
    "language": "Language",
    "carePhase": "Care Phase",
    "registered": "Registered",
    "assessments": "Assessments",
    "noAssessments": "No assessments yet. Click \"Start Assessment\" to begin.",
    "continueAssessment": "Continue Assessment",
    "notFound": "Patient not found",
    "step": "Step",
    "reexam": {
      "title": "Previous Assessment Found",
      "message": "This patient has a previous assessment from {{date}}. Would you like to:",
      "startReexam": "Start Re-Examination",
      "reexamDesc": "Compare with previous assessment. Existing complaints are pre-loaded. You can add new complaints.",
      "startNew": "Start New Assessment",
      "newDesc": "Fresh full assessment: different reason for visit or new patient presentation."
    },
    "deleteModal": {
      "title": "Delete Patient",
      "message": "Are you sure you want to permanently delete {{name}} and all their assessments? This cannot be undone.",
      "typeToConfirm": "Type the patient's last name ({{lastName}}) to confirm:",
      "deleting": "Deleting..."
    },
    "needsRepair": {
      "title": "This patient record needs repair",
      "body": "Part of this record can't be read right now. It has been reported and nothing has been changed. Please don't create the patient again. Contact support if you need this record today."
    },
    "loadFailed": "Couldn't load this patient."
  },
  "patientForm": {
    "editTitle": "Edit Patient",
    "newTitle": "New Patient",
    "firstNameLabel": "First Name *",
    "lastNameLabel": "Last Name *",
    "dateOfBirthLabel": "Date of Birth *",
    "genderLabel": "Gender",
    "selectGender": "Select...",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "phoneLabel": "Phone",
    "emailLabel": "Email",
    "languageLabel": "Language",
    "english": "English",
    "greek": "Greek",
    "russian": "Russian",
    "hebrew": "Hebrew",
    "carePhaseLabel": "Care Phase",
    "initial": "Initial",
    "activeCare": "Active Care",
    "maintenance": "Maintenance",
    "wellness": "Wellness",
    "saving": "Saving...",
    "updatePatient": "Update Patient",
    "createPatient": "Create Patient",
    "guardianLabel": "Guardian / Parent Name",
    "relationshipLabel": "Relationship to Patient",
    "selectRelationship": "Select relationship",
    "mother": "Mother",
    "father": "Father",
    "legalGuardian": "Legal Guardian",
    "carer": "Carer",
    "minorWarning": "Patient is under 18 ({{age}} {{unit}} old). Guardian information required",
    "guardianNamePlaceholder": "e.g. Maria Georgiou",
    "dayPlaceholder": "DD",
    "monthPlaceholder": "MM",
    "yearPlaceholder": "YYYY",
    "errors": {
      "required": "First name, last name, and date of birth are required",
      "saveFailed": "Failed to save patient",
      "guardianRequired": "Guardian / Parent name is required for patients under 18",
      "genderRequired": "Sex is required"
    },
    "contactInfo": "Contact information",
    "editDescription": "Update patient details below",
    "newDescription": "Fill in the details to register a new patient",
    "personalInfo": "Personal information",
    "preferences": "Preferences"
  },
  "aiPaste": {
    "analyze": "Analyze with AI",
    "analyzing": "Analyzing...",
    "aiTruncated": "AI analysis didn't complete. The AI's answer exceeded its space limit. We already retried automatically. Please try again; for very long histories, pasting a smaller section can help. You can also switch to the guided questionnaire.",
    "examSkippedTitle": "{{count}} examination result(s) could not be stored and were NOT saved:",
    "examSkippedUnknownKey": "this test is not in the test catalogue",
    "examSkippedInvalidResult": "the result value was not recognised",
    "examSkippedHelp": "Everything else was saved. Record these in the examination step if they are real findings.",
    "removedTitle": "{{count}} suggested complaint(s) removed by the integrity check:",
    "removedExamDerived": "Removed: derived from examination findings",
    "removedNoEvidence": "Removed: no verbatim evidence in the notes",
    "strippedNegatives": "Some \"no ...\" statements had no support in your notes and were removed. Allergies without a stated status are shown as not recorded.",
    "deadline": "AI analysis took too long and was stopped after 150 seconds. Nothing from this attempt was saved. Please try again, or switch to the guided questionnaire.",
    "retry": "Retry",
    "clientTimeout": "The AI analysis didn't answer in time, so it was stopped. Nothing from this attempt was applied. Please try again, or switch to the guided questionnaire."
  },
  "holistic": {
    "invalid": "AI clinical analysis didn't complete. The AI's answer was incomplete or malformed. We already retried automatically. Please try again.",
    "longWait": "Still working. The AI may be making a second attempt. This can take up to two minutes.",
    "takes": "This usually takes under a minute",
    "retry": "Try Again",
    "notGenerated": "AI clinical analysis has not been generated for this assessment.",
    "notGeneratedInvalid": "The stored AI analysis was incomplete and has been set aside. Generate it again when ready.",
    "regenerate": "Generate analysis",
    "saveFailed": "Could not save the holistic analysis. Your edits were not stored. Please try again."
  },
  "aiCaller": {
    "soapInvalid": "AI SOAP note didn't complete. The AI's answer was incomplete or malformed. We already retried automatically. Please try again.",
    "summaryInvalid": "AI summary didn't complete. The AI's answer was incomplete or malformed. We already retried automatically. Please try again.",
    "secondOpinionInvalid": "AI second opinion didn't complete. The AI's answer was incomplete or malformed. We already retried automatically. Please try again.",
    "letterInvalid": "The AI letter didn't complete. The AI's answer was incomplete or malformed. We already retried automatically. Please try again.",
    "retry": "Try again",
    "translationInvalid": "The report translation didn't complete. The AI's answer was incomplete, malformed, or not in the target language. We already retried automatically. Please try again.",
    "uploadTextInvalid": "The upload summary didn't complete. The AI's answer was incomplete. We already retried automatically. Please try again.",
    "postureExtractInvalid": "PostureScreen extraction didn't complete. The AI's answer was incomplete or malformed. We already retried automatically. Please try again."
  },
  "assessment": {
    "new": "New Assessment",
    "resume": "Resume",
    "complete": "Complete",
    "draft": "Draft",
    "fullAssessment": "Full Assessment",
    "quickScore": "Quick Score",
    "reExam": "Re-Examination",
    "steps": {
      "medicalHistory": "Medical History",
      "chiefComplaints": "Chief Complaints",
      "physicalExamination": "Physical Examination",
      "postureAnalysis": "Posture Analysis",
      "investigations": "Investigations",
      "outcomeMeasures": "Outcome Measures",
      "ddxReview": "DDx Review",
      "managementPlan": "Management Plan",
      "reportGeneration": "Report Generation"
    },
    "readOnly": "This assessment has been finalized and is read-only.",
    "completedBy": "These steps were completed by {{name}}. Contact them to make changes.",
    "completedByClinician": "These steps were completed by the clinician. Contact them to make changes.",
    "bodyMap": {
      "instruction": "Tap the body regions where the patient has pain or symptoms. Select up to 5 areas.",
      "noRegions": "No regions selected",
      "regionsSelected": "{{count}} region(s) selected",
      "startDetail": "Start Complaint Detail",
      "editRegions": "Edit regions",
      "regions": "Regions: "
    },
    "redFlags": {
      "title": "Red Flags Detected",
      "requireAction": "The following red flags require clinician action before proceeding.",
      "clear": "Red flag screening complete. No concerns requiring immediate action.",
      "instruction": "Answer YES or NO to each screening question. These are asked once for the entire assessment.",
      "backToComplaints": "Back to complaints",
      "submitting": "Submitting...",
      "submitAndContinue": "Submit Screening & Continue"
    },
    "saveAsDraft": "Save as Draft: Front Desk Will Complete",
    "continueToReport": "Continue to Report Generation",
    "finalize": {
      "instruction": "Once all sections are ready, finalize the report to mark it complete.",
      "button": "Finalize Report",
      "success": "Report finalized and ready for patient."
    },
    "stepComingSoon": "Step {{step}}: content coming soon.",
    "loadingAssessment": "Loading assessment…",
    "goBack": "Go back",
    "noPatient": "No patient selected. Start an assessment from a patient's profile.",
    "viewPatients": "View Patients",
    "finalized": "Finalized",
    "navigation": {
      "previousSection": "Previous Section",
      "continueTo": "Continue to {{step}}",
      "nextSection": "Next Section",
      "completeAssessment": "Complete Assessment",
      "saveAndContinueTo": "Save & Continue to {{step}}"
    }
  },
  "clinical": {
    "findings": "Clinical findings",
    "observations": "Observations",
    "workingHypothesis": "Working hypothesis",
    "assessment": "Assessment",
    "aiSuggested": "AI-suggested, awaiting clinician confirmation",
    "confirmedBy": "Confirmed by clinician",
    "redFlag": "Red flag: requires immediate attention"
  },
  "medicalHistory": {
    "treatmentGoals": "Treatment Goals",
    "pastMsk": "Past MSK Conditions",
    "medications": "Current Medications",
    "surgicalHistory": "Surgical History",
    "familyHistory": "Family History",
    "systemsReview": "Systems Review",
    "allergies": "Allergies",
    "lifestyle": "Lifestyle Assessment",
    "loading": "Loading medical history...",
    "noMedications": "No current medications",
    "noSurgical": "No surgical history recorded.",
    "noFamily": "No family history recorded.",
    "noAllergies": "No allergies recorded.",
    "dosage": "Dosage",
    "searchMedications": "Search medications",
    "year": "Year",
    "selectBodyRegion": "Select body region",
    "procedureName": "Procedure name",
    "allergenName": "Allergen name",
    "pregnancyStatus": "Pregnancy Status",
    "title": "Medical History",
    "pastMedical": "Past Medical History",
    "currentMedications": "Current Medications",
    "socialHistory": "Social History",
    "reviewOfSystems": "Review of Systems",
    "noConditions": "No conditions reported",
    "addCondition": "Add Condition",
    "addMedication": "Add Medication",
    "addAllergy": "Add Allergy",
    "condition": "Condition",
    "medication": "Medication",
    "frequency": "Frequency",
    "allergen": "Allergen",
    "reaction": "Reaction",
    "severity": "Severity",
    "mild": "Mild",
    "moderate": "Moderate",
    "severe": "Severe",
    "occupation": "Occupation",
    "smokingStatus": "Smoking Status",
    "alcoholUse": "Alcohol Use",
    "exerciseLevel": "Exercise Level",
    "never": "Never",
    "former": "Former",
    "current": "Current",
    "none": "None",
    "light": "Light",
    "heavy": "Heavy",
    "sedentary": "Sedentary",
    "active": "Active",
    "veryActive": "Very Active",
    "saveAndContinue": "Save & Continue to Complaints",
    "additionalNotes": "Additional conditions or notes",
    "shortPastMsk": "Past MSK",
    "shortMedications": "Medications",
    "shortSurgical": "Surgical",
    "shortFamily": "Family",
    "shortSystems": "Systems",
    "shortAllergies": "Allergies",
    "shortLifestyle": "Lifestyle",
    "birthSummary": "Birth Summary",
    "mothersHealth": "Mother's Health",
    "immunisations": "Immunisations",
    "shortBirth": "Birth",
    "shortMother": "Mother",
    "shortVaccines": "Vaccines",
    "noCurrentMeds": "No current medications",
    "addFamilyCondition": "Add family condition",
    "noFamilyHistory": "No family history recorded.",
    "systemsToggleDesc": "Toggle each system to indicate positive findings, then add notes if needed.",
    "notesPlaceholder": "Notes for {{system}} findings...",
    "pregnancyTitle": "Pregnancy Status",
    "notPregnant": "Not pregnant",
    "currentlyPregnant": "Currently pregnant",
    "possiblyPregnant": "Possibly pregnant",
    "unknown": "Unknown"
  },
  "complaints": {
    "region": "Region",
    "complaintReview": "Complaint Review",
    "aiParsedBadge": "AI-parsed · tap to confirm",
    "confirmError": "Could not confirm. Please try again",
    "reviewInstructions": "Review saved complaints below. You can add another complaint region or continue to red flag screening.",
    "loadingComplaints": "Loading complaints...",
    "noComplaintsSaved": "No complaints saved yet. Please add at least one complaint.",
    "central": "Central",
    "painLabel": "Pain: {{score}}/10",
    "addAnother": "+ Add Another Complaint",
    "maxReached": "Max 5 complaints reached",
    "editRedFlags": "Edit Red Flag Responses",
    "continueToRedFlags": "Continue to Red Flag Screening →",
    "complaintsCount": "{{count}} complaint(s) saved",
    "newComplaint": "New Complaint",
    "bodyMapInstructions": "Tap the body regions where the patient has pain or symptoms. Select up to 5 areas.",
    "noRegionsSelected": "No regions selected",
    "regionsSelected": "{{count}} region(s) selected",
    "startComplaintDetail": "Start Complaint Detail →",
    "editRegions": "← Edit regions",
    "title": "Chief Complaints",
    "side": "Side",
    "painLevel": "Pain Level (NRS)",
    "onset": "Onset",
    "nature": "Nature of Pain",
    "aggravating": "Aggravating Factors",
    "relieving": "Relieving Factors",
    "radiation": "Radiation Pattern",
    "dermatome": "Dermatomal Distribution",
    "neuroSymptoms": "Neurological Symptoms",
    "functionalImpact": "Functional Impact",
    "whichSide": "Which side is the pain on?",
    "left": "Left",
    "right": "Right",
    "bilateral": "Bilateral",
    "noPain": "No pain",
    "worstPain": "Worst pain",
    "sudden": "Sudden",
    "gradual": "Gradual",
    "sharp": "Sharp",
    "dull": "Dull",
    "aching": "Aching",
    "burning": "Burning",
    "shooting": "Shooting",
    "throbbing": "Throbbing",
    "stabbing": "Stabbing",
    "doesRadiate": "Does the pain radiate?",
    "whereRadiate": "Where exactly does it radiate?",
    "question": "Question",
    "newComplaintNote": "This is a new complaint (not present in previous assessment)",
    "loadingComplaint": "Loading complaint data...",
    "saveAndContinue": "Save & Continue to Red Flags",
    "chronicity": "How long have you had this complaint?",
    "haLocation": "Where is your headache located?",
    "haCharacter": "How would you describe the headache?",
    "haDuration": "How long does each episode last?",
    "haFrequency": "How often do you get headaches?",
    "haAssociated": "Do you experience any of these with your headache?",
    "haTriggers": "What triggers or worsens your headache?",
    "haRelief": "What helps relieve your headache?",
    "redFlagScreening": "Red Flag Screening",
    "dzType": "How would you describe your dizziness?",
    "dzTiming": "How long does each episode last?",
    "dzPosition": "Is your dizziness affected by position?",
    "dzAssociated": "Do you experience any of these with your dizziness?",
    "dzTriggers": "What triggers your dizziness?",
    "paedReporter": "Who is reporting the symptoms?",
    "paedDailyImpact": "Impact on daily activities",
    "paedRecentHistory": "Recent history",
    "paedDevelopmental": "Developmental considerations",
    "paedFamilyHistory": "Family history (paediatric)",
    "selectDuration": "Select the duration of symptoms",
    "noDestinations": "No specific destinations for this region.",
    "selectDermatome": "Select the dermatomal distribution (if identifiable):",
    "selectAllApply": "Select all that apply",
    "selectAllApplyMultiType": "Select all that apply. Patients may experience more than one type",
    "selectAllApplyDuration": "Select all that apply. Episodes may vary in duration",
    "selectTypicalDuration": "Select the typical duration of each episode",
    "selectTypicalFrequency": "Select the typical frequency",
    "redFlagInstructions": "Answer YES or NO for each question. Any \"yes\" answer may indicate a need for urgent referral.",
    "clinicalNote": "Clinical Note",
    "paedReporterHint": "Who is reporting the symptoms?",
    "paedDailyImpactHint": "How is the pain affecting your child's daily activities? Select all that apply.",
    "paedRecentHistoryHint": "Any recent changes? Select all that apply.",
    "paedDevelopmentalHint": "Any developmental considerations? Select all that apply.",
    "paedFamilyHistoryHint": "Relevant family history? Select all that apply.",
    "centralMidline": "Central/Midline",
    "centralFrontal": "Central/Frontal",
    "occipital": "Occipital",
    "onsetTraumatic": "Traumatic",
    "onsetInsidious": "Insidious",
    "onsetPostSurgical": "Post-surgical",
    "onsetRepetitiveStrain": "Repetitive strain",
    "onsetUnknown": "Unknown",
    "chronicityAcute": "Less than 2 weeks (acute)",
    "chronicitySubacute": "2–6 weeks (subacute)",
    "chronicityChronicLong": "More than 12 weeks (chronic)",
    "chronicityChronic": "6–12 weeks (chronic)",
    "cramping": "Cramping",
    "tingling": "Tingling",
    "numbness": "Numbness",
    "radiationNone": "None",
    "radiationArm": "Down the arm",
    "radiationLeg": "Down the leg",
    "radiationBack": "Across the back",
    "radiationShoulder": "Into the shoulder",
    "radiationHand": "Into the hand/fingers",
    "radiationFoot": "Into the foot/toes",
    "radiationChest": "Around the chest",
    "radiationGroin": "Into the groin",
    "radiationButtock": "Into the buttock",
    "neuroWeakness": "Weakness",
    "neuroBalance": "Loss of balance",
    "neuroCoordination": "Loss of coordination",
    "neuroAlteredSensation": "Altered sensation",
    "impactUnableWork": "Unable to work",
    "impactReducedWork": "Reduced work capacity",
    "impactSleeping": "Difficulty sleeping",
    "impactDaily": "Difficulty with daily activities",
    "impactSelfCare": "Difficulty with self-care",
    "impactExercise": "Unable to exercise",
    "impactMobility": "Reduced mobility",
    "impactSocial": "Social withdrawal",
    "impactMood": "Mood affected",
    "impactNone": "None significant",
    "haLocOneSame": "One side only (always same side)",
    "haLocOneAlt": "One side (alternating sides)",
    "haLocBoth": "Both sides / all over",
    "haLocBack": "Back of head / base of skull",
    "haLocForehead": "Forehead / behind eyes",
    "haLocTemple": "Temple region",
    "haLocTop": "Top of head",
    "haCharThrobbing": "Throbbing / pulsating",
    "haCharPressing": "Pressing / tightening (like a band)",
    "haCharSharp": "Sharp / stabbing",
    "haCharDull": "Dull / aching",
    "haDurSeconds": "Seconds to minutes",
    "haDur30min": "30 minutes to 4 hours",
    "haDur4h": "4 to 72 hours",
    "haDurConstant": "Constant / always there",
    "haDurVariable": "Variable",
    "haFreqDaily": "Daily or almost daily",
    "haFreqSeveral": "Several times per week",
    "haFreqWeekly": "Weekly",
    "haFreqMonthly": "Monthly or less",
    "haFreqEpisodic": "Episodic / comes and goes",
    "startFromTemplate": "Start from Template",
    "hideMap": "Hide pain map",
    "markLocation": "Mark exact pain location (optional)"
  },
  "physicalExam": {
    "primaryTests": "Primary Tests",
    "secondaryTests": "Secondary Tests",
    "romSpecialized": "ROM / Specialized",
    "positive": "Positive",
    "negative": "Negative",
    "notTested": "Not Tested",
    "left": "Left",
    "right": "Right",
    "bilateral": "Bilateral",
    "essentialTests": "Essential Tests",
    "recommendedTests": "Recommended Tests",
    "additionalTests": "Additional Tests",
    "normal": "Normal",
    "restricted": "Restricted",
    "painful": "Painful",
    "hypermobile": "Hypermobile",
    "noAbnormalities": "No Abnormalities Found",
    "noSpinalDysfunction": "No Spinal Dysfunction Found",
    "collapse": "Collapse",
    "expand": "Expand",
    "addNotes": "+ Add notes",
    "hideNotes": "Hide notes",
    "clinicalNotes": "Clinical notes...",
    "searchTests": "Search tests by name...",
    "all": "All",
    "title": "Physical Examination",
    "selectTests": "Select Tests to Perform",
    "recommended": "Recommended",
    "performed": "Performed",
    "notPerformed": "Not Performed",
    "inconclusive": "Inconclusive",
    "notes": "Notes",
    "testResult": "Test Result",
    "saveResults": "Save Results",
    "noTestsSelected": "No tests selected",
    "selectRegion": "Select a body region to see available tests",
    "allTests": "All Tests",
    "differentialTests": "Differential Diagnosis Tests",
    "clinicalGuide": "Clinical Assessment Guide",
    "patternMatch": "Pattern Match",
    "match": "match",
    "basedOnPresentation": "Based on clinical presentation analysis",
    "showProcedureDetails": "Show procedure details",
    "essentialDesc": "Must perform: critical for ruling in/out primary diagnoses",
    "recommendedDesc": "Should perform: strengthens clinical reasoning",
    "additionalDesc": "If indicated, based on presentation complexity"
  },
  "posture": {
    "manualAssessment": "Manual Assessment",
    "cameraAssessment": "Camera Assessment",
    "shoulderROM": "Shoulder ROM",
    "advancedMeasurements": "Advanced Measurements (14 metrics)",
    "removeImage": "Remove image",
    "cameraDataPopulated": "Camera data populated"
  },
  "investigations": {
    "title": "Investigations",
    "description": "Upload imaging (X-ray, MRI, CT) and/or enter lab results. Both sections are optional.",
    "skipAll": "Skip All",
    "imaging": "Imaging (X-ray, MRI, CT, Ultrasound)",
    "labTests": "Lab Tests (Blood Work, Markers)"
  },
  "improvement": {
    "previous": "Previous",
    "current": "Current",
    "noData": "No Data",
    "significantImprovement": "Significant Improvement",
    "moderateImprovement": "Moderate Improvement",
    "declining": "Declining",
    "stable": "Stable",
    "mcidMet": "MCID ✓",
    "loading": "Loading improvement report...",
    "noComparisonData": "No comparison data available.",
    "reportTitle": "Re-Examination Improvement Report",
    "comparisonSubtitle": "Comparison with previous assessment",
    "printReport": "Print Report",
    "painSeverityChanges": "Pain Severity Changes",
    "outcomeMeasureChanges": "Outcome Measure Changes",
    "clinicallySignificantChanges": "Clinically Significant Changes",
    "wellnessScore": "Body Performance Score",
    "mcidExplanation": "MCID = Minimal Clinically Important Difference. Changes meeting or exceeding MCID are considered clinically meaningful.",
    "loadError": "Failed to load comparison data",
    "descNoMeasures": "No measures available for comparison.",
    "descImproved": "{{improved}} of {{total}} measures improved.",
    "descModerate": "{{improved}} of {{total}} measures improved, {{worsened}} worsened.",
    "descDeclining": "{{worsened}} of {{total}} measures worsened. Consider plan modification.",
    "descMixed": "Mixed results: {{improved}} improved, {{worsened}} worsened, {{unchanged}} unchanged."
  },
  "reexam": {
    "improved": "Improved",
    "worsened": "Worsened",
    "noChange": "No Change",
    "noMeasures": "No outcome measures to display."
  },
  "paediatricReEvalReport": {
    "title": "Your Child's Progress Report",
    "yearsOld": "{{age}} years old",
    "reEvalFollowup": "Re-evaluation Follow-up",
    "dearParents": "Dear Parents,",
    "introText": "Thank you for bringing {{name}} back for their follow-up appointment. We're pleased to share how they are progressing and what the next steps in their care look like.",
    "howChildIsDoing": "How {{name}} Is Doing",
    "lastVisit": "Last Visit",
    "today": "Today",
    "improvement": "Improvement",
    "painImprovementMessage": "That's a {{pct}}% improvement! Great progress.",
    "greatNews": "Great news!",
    "improvingMessage": "We're delighted to hear that {{name}} is feeling better.",
    "muchBetterNote": "The significant improvement shows that their body is responding really well to care.",
    "worseMessage": "We understand this can be concerning. Please know that progress isn't always linear, especially with children. Let us explain what we've found today and how we're adjusting the plan to help {{name}} get better.",
    "noChangeMessage": "While the symptoms haven't changed significantly yet, this is not uncommon in the early stages of care. We're monitoring {{name}}'s progress carefully and adjusting the plan accordingly.",
    "developmentalProgress": "Developmental Progress",
    "whatWeFoundToday": "What We Found Today",
    "whatWeFoundIntro": "Here is a summary of {{name}}'s current conditions and how they are progressing:",
    "statusImproving": "Improving",
    "statusStable": "Stable",
    "statusNeedsAttention": "Needs Attention",
    "statusUnderReview": "Under Review",
    "monitoring": "We are monitoring this condition as part of {{name}}'s care plan.",
    "noConditionsConfirmed": "No specific conditions confirmed at this time.",
    "updatedTreatmentPlan": "{{name}}'s Updated Treatment Plan",
    "updatedPlanIntro": "Based on today's findings, here is the updated plan for {{name}}'s care:",
    "whatYouCanDoAtHome": "What You Can Do at Home",
    "infantTitle": "Advice for Infants (0-1 year)",
    "infantTummyTime": "Tummy time:",
    "infantTummyTimeText": "3-5 minutes, several times a day, gradually increasing as tolerated",
    "infantFeeding": "Feeding:",
    "infantFeedingText": "Alternate sides during feeding to encourage symmetrical movement",
    "infantCarrying": "Carrying:",
    "infantCarryingText": "Vary carrying positions: hip carry, front face-out, supported sit",
    "infantSleep": "Sleep:",
    "infantSleepText": "Place on back for sleep, alternate head position at each nap",
    "infantPlay": "Play:",
    "infantPlayText": "Use toys to encourage reaching and turning to both sides",
    "toddlerTitle": "Advice for Toddlers (1-3 years)",
    "toddlerMovement": "Movement:",
    "toddlerMovementText": "Encourage climbing, crawling through tunnels, and balance activities",
    "toddlerShoes": "Shoes:",
    "toddlerShoesText": "Choose flexible, supportive shoes, and bare feet at home when safe",
    "toddlerWalking": "Walking patterns:",
    "toddlerWalkingText": "Minor toe-walking or in-toeing is often normal at this age",
    "toddlerActivities": "Activities:",
    "toddlerActivitiesText": "Dancing, soft ball play, and gentle jumping help coordination",
    "childTitle": "Advice for Children (3-12 years)",
    "childSport": "Sport & activity:",
    "childSportText": "Encourage 60 minutes of physical activity daily. Variety is best",
    "childBackpack": "Backpack:",
    "childBackpackText": "Should weigh no more than 10-15% of body weight, use both straps",
    "childScreen": "Screen posture:",
    "childScreenText": "Eyes level with screen, feet flat, breaks every 20-30 minutes",
    "childFun": "Fun exercises:",
    "childFunText": "\"Animal walks\" (bear crawls, crab walks), \"superhero poses\" (superman hold), and wall angels",
    "childRest": "Rest vs activity:",
    "childRestText": "If pain is mild, gentle activity usually helps more than complete rest",
    "adolescentTitle": "Advice for Adolescents (12-18 years)",
    "adolescentSport": "Sport-specific:",
    "adolescentSportText": "Warm up properly, don't play through significant pain",
    "adolescentGrowth": "Growth spurts:",
    "adolescentGrowthText": "Extra stretching during growth periods helps prevent tightness",
    "adolescentStudy": "Study/gaming posture:",
    "adolescentStudyText": "Set up workspace at correct height, take regular breaks",
    "adolescentStrength": "Strengthening:",
    "adolescentStrengthText": "Body-weight exercises (planks, squats, lunges) build a strong foundation",
    "adolescentReturn": "When to return:",
    "adolescentReturnText": "Contact us if pain worsens, moves to a new area, or affects daily activities",
    "specificHomeAdvice": "Specific Home Care Advice:",
    "do": "Do:",
    "avoid": "Avoid:",
    "recommendedExercises": "Recommended Exercises:",
    "whenToContactUs": "When to Contact Us",
    "contactImmediatelyIf": "Contact us immediately if:",
    "contactImmediate1": "{{name}} develops a fever with joint pain",
    "contactImmediate2": "{{name}} refuses to use a limb or bear weight",
    "contactImmediate3": "Severe pain that worsens despite rest",
    "contactImmediate4": "You notice any new swelling, redness, or warmth around a joint",
    "contactImmediate5": "Any sudden change in how {{name}} walks or moves",
    "bookSoonerIf": "Book a sooner appointment if:",
    "bookSooner1": "Pain is not improving after 2 weeks",
    "bookSooner2": "New symptoms develop",
    "bookSooner3": "You have any concerns about {{name}}'s progress",
    "otherwiseSeeAgain": "Otherwise, we'll see {{name}} again as scheduled in their treatment plan above.",
    "noteForParents": "A Note for Parents",
    "parentsNote1": "We understand that seeing your child in pain or discomfort can be worrying. Please know that {{name}}'s condition is common, treatable, and responding to care. Children are remarkably resilient, and with the right support, most musculoskeletal conditions in children resolve well. We're here to guide both you and {{name}} through this journey.",
    "growingPainsTitle": "About growing pains:",
    "growingPainsNote": "Growing pains are a normal part of childhood and do NOT indicate anything wrong with your child's bones or joints. They are temporary and will resolve as your child grows. A warm bath before bed and gentle massage of the affected area can help.",
    "parentsNote2": "If you ever have questions between appointments, please don't hesitate to contact us. No question is too small when it comes to your child's health.",
    "nextSteps": "Next Steps",
    "readyToBook": "Ready to book {{name}}'s next appointment?",
    "scanToBook": "Scan to book",
    "referralTitle": "Know another family we could help?",
    "referralText": "We'd love to help your family and friends too. If you know someone whose child could benefit from our care, we'd be honoured to welcome them.",
    "disclaimer": "This report is intended for the parents/guardians of the patient and is prepared for informational purposes. It does not replace medical advice. If you have concerns about your child's health, please contact your healthcare provider.",
    "reliefCare": "Relief Care",
    "rehabilitation": "Rehabilitation",
    "wellnessCare": "Wellness Care"
  },
  "paediatricProgress": {
    "loading": "Loading progress data...",
    "title": "Progress Since Last Visit",
    "painLevels": "Pain Levels",
    "improving": "Improving",
    "worsening": "Worsening",
    "stable": "Stable",
    "resolved": "Resolved",
    "new": "New",
    "errorLoad": "Could not load progress data",
    "retry": "Retry",
    "empty": "No previous visit data to compare",
    "parentConcernChanges": "Parent Concern Changes",
    "ongoing": "Ongoing",
    "treatmentResponseTitle": "Treatment Response (Parent-Reported)",
    "developmentalMilestonesTitle": "Developmental Milestones Achieved",
    "exerciseCompliance": "Exercise Compliance",
    "outcomeMeasures": "Outcome Measures",
    "wellnessScore": "Body Performance Score"
  },
  "paediatricReEval": {
    "title": "Parent / Guardian Questionnaire",
    "subtitle": "Please answer the following questions about your child's progress since the last visit.",
    "loading": "Loading questionnaire…",
    "errorLoad": "Couldn't load the questionnaire. Please try again.",
    "empty": "No previous data. Start answering the questions below.",
    "retry": "Retry",
    "savedDraft": "Answers saved",
    "saveError": "Couldn't save your answer. Please try again.",
    "completed": "Questionnaire complete. Thank you!",
    "sectionParentConcerns": "Parent Concerns",
    "sectionDevelopment": "Development",
    "sectionTreatmentResponse": "Treatment Response",
    "devBanner": "Developmental Progress Check: these questions help us track your child's developmental milestones.",
    "continue": "Continue →",
    "back": "← Back",
    "complete": "✓ Complete Questionnaire & Continue",
    "noPain": "No pain",
    "worstPain": "Worst pain",
    "q1": {
      "title": "Q1: How has your child been since the last visit?",
      "options": {
        "Much better": "Much better",
        "Slightly better": "Slightly better",
        "No change": "No change",
        "Slightly worse": "Slightly worse",
        "Much worse": "Much worse"
      }
    },
    "q2": {
      "title": "Q2: What are your main concerns today?",
      "options": {
        "Pain is still present": "Pain is still present",
        "Pain has moved to a different area": "Pain has moved to a different area",
        "New symptoms have appeared": "New symptoms have appeared",
        "Child is not improving as expected": "Child is not improving as expected",
        "Child is avoiding activities": "Child is avoiding activities",
        "Sleep is still disturbed": "Sleep is still disturbed",
        "Concerned about posture": "Concerned about posture",
        "Concerned about development": "Concerned about development",
        "Limping or favouring one side": "Limping or favouring one side",
        "School/sports participation affected": "School/sports participation affected",
        "No concerns — here for routine check": "No concerns, here for routine check"
      }
    },
    "q3": {
      "title": "Q3: Has anything changed since the last visit?",
      "options": {
        "Started a new sport or activity": "Started a new sport or activity",
        "Had a fall or injury": "Had a fall or injury",
        "Been unwell (illness, fever)": "Been unwell (illness, fever)",
        "Growth spurt noticed": "Growth spurt noticed",
        "Started or stopped medication": "Started or stopped medication",
        "Changed shoes or school bag": "Changed shoes or school bag",
        "Nothing has changed": "Nothing has changed"
      }
    },
    "q4": {
      "title": "Q4: How is your child coping emotionally?",
      "options": {
        "Happy and active as usual": "Happy and active as usual",
        "A bit frustrated by the limitation": "A bit frustrated by the limitation",
        "Anxious about the condition": "Anxious about the condition",
        "Withdrawn or less active than usual": "Withdrawn or less active than usual",
        "No noticeable change": "No noticeable change"
      }
    },
    "q5": {
      "title": "Q5: Has your child been doing the home exercises/advice we recommended?",
      "options": {
        "Yes, consistently": "Yes, consistently",
        "Yes, but not regularly": "Yes, but not regularly",
        "Sometimes": "Sometimes",
        "Rarely": "Rarely",
        "Not at all": "Not at all",
        "Exercises were not prescribed": "Exercises were not prescribed"
      }
    },
    "q6": {
      "title": "Q6: On a scale of 0-10, how would you rate your child's pain now?"
    },
    "q7": {
      "title": "Q7: Since the last visit, have you noticed any changes in your child's movement?",
      "options": {
        "Moving more freely": "Moving more freely",
        "Started crawling / walking / running (milestone achieved)": "Started crawling / walking / running (milestone achieved)",
        "Seems less coordinated than before": "Seems less coordinated than before",
        "Head control has improved": "Head control has improved",
        "Still favouring one side": "Still favouring one side",
        "No change noticed": "No change noticed"
      }
    },
    "q8": {
      "title": "Q8: Any concerns about feeding?",
      "options": {
        "Feeding well from both sides": "Feeding well from both sides",
        "Still prefers one side": "Still prefers one side",
        "Difficulty latching or feeding": "Difficulty latching or feeding",
        "No concerns": "No concerns"
      }
    },
    "q9": {
      "title": "Q9: How is your child sleeping?",
      "options": {
        "Sleeping well through the night": "Sleeping well through the night",
        "Waking due to discomfort": "Waking due to discomfort",
        "Sleeping in an unusual position": "Sleeping in an unusual position",
        "Sleep has improved since last visit": "Sleep has improved since last visit",
        "No change": "No change"
      }
    },
    "q10": {
      "title": "Q10: Which treatments has your child received since the last visit?",
      "options": {
        "Chiropractic adjustments": "Chiropractic adjustments",
        "Soft tissue therapy": "Soft tissue therapy",
        "Exercise therapy": "Exercise therapy",
        "Home exercises only": "Home exercises only",
        "Other healthcare provider treatment": "Other healthcare provider treatment",
        "No treatment received": "No treatment received"
      }
    },
    "q11": {
      "title": "Q11: How did your child respond to treatment?",
      "options": {
        "Pain reduced after treatment": "Pain reduced after treatment",
        "More mobile after treatment": "More mobile after treatment",
        "Temporary soreness after treatment (normal)": "Temporary soreness after treatment (normal)",
        "No noticeable effect": "No noticeable effect",
        "Symptoms worsened after treatment (important to note)": "Symptoms worsened after treatment (important to note)"
      }
    }
  },
  "outcomeMeasures": {
    "title": "Outcome Measures",
    "recommended": "recommended based on complaint regions",
    "vasAlreadyCaptured": "VAS pain rating is already captured in the complaint section.",
    "skipMeasures": "Skip Outcome Measures",
    "measureOf": "Measure {{current}} of {{total}}",
    "allComplete": "All suggested measures complete",
    "saveAndContinue": "Save & Continue",
    "ndi": "Neck Disability Index",
    "odi": "Oswestry Disability Index",
    "dash": "DASH (Disabilities of Arm, Shoulder, Hand)",
    "lefs": "Lower Extremity Functional Scale",
    "phq9": "Patient Health Questionnaire-9",
    "gad7": "Generalized Anxiety Disorder-7",
    "startBack": "STarT Back Screening Tool",
    "tsk11": "Tampa Scale for Kinesiophobia-11",
    "severity": {
      "noDisability": "No disability",
      "mild": "Mild",
      "moderate": "Moderate",
      "severe": "Severe",
      "fairlySevere": "Fairly severe",
      "verySevere": "Very severe",
      "complete": "Complete disability"
    }
  },
  "ddx": {
    "workingHypotheses": "Working Hypotheses",
    "confirmed": "Confirmed",
    "acknowledged": "Acknowledged",
    "confidence": {
      "strong": "Strong",
      "probable": "Probable",
      "possible": "Possible",
      "lessLikely": "Less Likely",
      "unlikely": "Unlikely"
    },
    "acknowledgeAndConfirm": "Acknowledge & Confirm",
    "showEvidence": "Show Evidence",
    "hideEvidence": "Hide Evidence",
    "supportingEvidence": "Supporting Evidence",
    "addConditionManually": "Add Condition Manually",
    "searchAndAdd": "Search & Add Condition",
    "searchPlaceholder": "Search by condition name, ICD code, or body region...",
    "noMatchingConditions": "No matching conditions found",
    "typeToSearch": "Type at least 2 characters to search",
    "confirmAtLeastOne": "Please confirm at least one working hypothesis before finalizing.",
    "finalizing": "Finalizing...",
    "finalizeAssessment": "Finalize Assessment",
    "title": "Differential Diagnosis Review",
    "confidenceLabel": "confidence",
    "status": {
      "suggested": "Suggested",
      "confirmed": "Confirmed",
      "overridden": "Overridden",
      "rejected": "Rejected",
      "clinicianAdded": "Clinician Added",
      "notSelected": "Not selected"
    },
    "confirmBtn": "Confirm",
    "rejectBtn": "Reject",
    "overrideBtn": "Override",
    "redFlagStatus": "Red Flag Status",
    "allRedFlagsRequired": "All red flags must be acknowledged before finalizing",
    "aiSecondOpinion": "Optional: AI Second Opinion",
    "analyzing": "Analyzing...",
    "getAiOpinion": "Get AI Second Opinion",
    "refreshAiOpinion": "Refresh AI Opinion",
    "noAiSuggestions": "No additional suggestions from AI",
    "ruleBasedComplete": "Rule-based analysis complete",
    "clusterAnalysis": "Cluster Analysis",
    "conditions": "Conditions",
    "commonFindings": "Common Findings",
    "systemicAlerts": "Systemic Pattern Alerts",
    "crossComplaintAlerts": "Cross-Complaint Pattern Alerts",
    "clinicalNote": "Clinical Note",
    "referTo": "Refer To",
    "additionalTests": "Additional Tests",
    "matchedCriteria": "Matched Criteria",
    "selectTop3": "Select Top 3",
    "selectBtn": "Select",
    "confirmedCount": "{{confirmed}} / {{total}} confirmed",
    "emergency": "EMERGENCY",
    "medicalEmergency": "MEDICAL EMERGENCY",
    "emergencyAction": "MEDICAL EMERGENCY: Requires Immediate Action",
    "emergencyFlags": "MEDICAL EMERGENCY FLAGS",
    "critical": "CRITICAL",
    "loadingReview": "Loading DDx review...",
    "noData": "No data available.",
    "selectHint": "Click <strong>Select</strong> to confirm working hypotheses. Only confirmed conditions are included in the management plan.",
    "hypothesisCount_one": "{{count}} hypothesis",
    "hypothesisCount_other": "{{count}} hypotheses",
    "skipAiSuggestions": "Skip AI Suggestions",
    "acceptBtn": "✓ Accept",
    "accepted": "✓ Accepted",
    "aiSuggestion": "AI Suggestion",
    "aiDismissed": "AI suggestions dismissed. Proceeding with manual DDx only.",
    "aiComprehensive": "No additional suggestions from AI. The rule-based analysis appears comprehensive.",
    "aiClinicalNotes": "AI Clinical Notes",
    "aiDescription": "Rule-based analysis complete. Want an AI second opinion?",
    "reasoning": "Reasoning:",
    "keyFindings": "Key Findings:",
    "recommendedTests": "Recommended Tests to Confirm/Rule Out:",
    "hideDetails": "Hide Details",
    "showDetails": "Show Details",
    "regions": {
      "lumbar": "Lumbar (Lower Back)",
      "cervical": "Cervical (Neck)",
      "thoracic": "Thoracic (Mid Back)",
      "shoulder": "Shoulder",
      "shoulder_left": "Left Shoulder",
      "shoulder_right": "Right Shoulder",
      "knee": "Knee",
      "knee_left": "Left Knee",
      "knee_right": "Right Knee",
      "hip": "Hip",
      "hip_left": "Left Hip",
      "hip_right": "Right Hip",
      "elbow": "Elbow",
      "elbow_left": "Left Elbow",
      "elbow_right": "Right Elbow",
      "wrist_hand": "Wrist/Hand",
      "wrist_hand_left": "Left Wrist/Hand",
      "wrist_hand_right": "Right Wrist/Hand",
      "ankle_foot": "Ankle/Foot",
      "ankle_foot_left": "Left Ankle/Foot",
      "ankle_foot_right": "Right Ankle/Foot",
      "tmj": "TMJ / Jaw"
    },
    "card": {
      "regions": "Regions:"
    },
    "acknowledgeAndDismiss": "Acknowledge & Dismiss",
    "dismissed": "Dismissed",
    "restoreDismissed": "Restore hypothesis",
    "dismissReasonLabel": "Reason for dismissal (required, min 5 characters)",
    "dismissReasonPlaceholder": "e.g. No saddle anaesthesia, normal bladder function, full painless ROM",
    "dismissConfirm": "Dismiss with reason",
    "dismissCancel": "Cancel",
    "escalateForEmergency": "Escalate for emergency evaluation",
    "escalateExplainer": "Only this switch puts emergency referral wording into GP / insurance letters.",
    "escalateAction": "Escalate",
    "escalationActive": "Escalation ON",
    "acknowledgeFlag": "Acknowledge & dismiss flag",
    "confirmDifferential": "Confirm differential",
    "confirming": "Confirming...",
    "confirmedToast": "Differential confirmed. Review your management plan. The report is issued when you press Complete."
  },
  "careJourney": {
    "painRelief": {
      "title": "Relief Care",
      "duration": "2–6 weeks",
      "description": "The first priority is reducing your pain and calming the tissues. We focus on gentle treatment, short visits and simple home strategies so you can sleep, move and work with less discomfort."
    },
    "rehabilitation": {
      "title": "Rehabilitation",
      "duration": "6 weeks – 6 months",
      "description": "Once pain is under control we rebuild strength, mobility and movement quality. Treatments become less frequent and you take on more active exercises. This is the phase that makes the improvement stick."
    },
    "maintenance": {
      "title": "Wellness Care",
      "duration": "Ongoing",
      "description": "Periodic check-ups keep the improvements you worked for. We review your posture, movement and any early warning signs, adjusting as needed so small issues don't turn into bigger problems."
    }
  },
  "managementPlan": {
    "title": "Management Plan",
    "panel": {
      "phases": {
        "title": "Phases of Care",
        "phaseLabel": "Phase"
      },
      "frequency": {
        "title": "Treatment Frequency",
        "empty": "No frequency blocks yet. Choose a preset above or click \"Add Block\" to start."
      }
    },
    "preset": {
      "rowLabel": "Preset"
    },
    "block": {
      "add": "Add Block",
      "delete": "Delete",
      "labelAria": "Block label",
      "frequencyPlaceholder": "e.g. 3x/week",
      "durationPlaceholder": "weeks",
      "visitsPlaceholder": "visits",
      "deleteMaintenanceConfirm": "Remove the Maintenance block? The patient will have no ongoing care block after the active phases."
    },
    "maintenance": {
      "label": "Maintenance"
    },
    "generating": "Generating...",
    "regenerate": "Regenerate Plan",
    "generate": "Generate Plan",
    "completeDdxFirst": "Please complete the DDx Review step first",
    "requiresHypothesis": "A management plan requires at least one confirmed working hypothesis from the DDx Review step.",
    "goToDdx": "← Go to DDx Review",
    "addressesConditions": "Treatment Plan Addresses {{count}} Condition(s)",
    "acrossRegions": "Across {{count}} Regions",
    "treatmentGoals": "Patient Treatment Goals",
    "goalsSelected": "{{count}} goal(s) selected. The treatment plan will be aligned with these objectives.",
    "noPlanYet": "No management plan generated yet. Click \"Generate Plan\" to create a comprehensive treatment plan based on confirmed conditions.",
    "expectedDuration": "Expected Duration",
    "visitSchedule": "Visit Schedule",
    "phase1": "Block 1",
    "phase2": "Block 2",
    "phase3": "Block 3",
    "understanding": "Understanding Your Condition(s)",
    "treatmentJourney": "Your Treatment Journey",
    "acutePhase": "Relief Care",
    "rehabPhase": "Rehabilitation",
    "maintenancePhase": "Wellness Check-ups",
    "visitFrequency": "Recommended Visit Frequency",
    "homeExercises": "What You Can Do at Home",
    "paediatricGuidance": "Paediatric Guidance",
    "techniques": "Techniques",
    "goals": "Goals",
    "duration": "Duration",
    "frequency": "Frequency",
    "precautions": "Precautions & Warnings",
    "generatePlan": "Generate Plan",
    "regeneratePlan": "Regenerate Plan",
    "needConfirmedHypothesis": "A management plan requires at least one confirmed working hypothesis",
    "confirmedConditions": "Confirmed Conditions",
    "treatmentPhases": "Treatment Phases",
    "referralCriteria": "Referral Criteria",
    "supplements": "Supplement Recommendations",
    "supplementsClinicianOnly": "Clinician reference, not for patient output",
    "evidenceBase": "Evidence Base",
    "phase": "Phase {{num}}:",
    "condition": "Condition",
    "criteria": "Criteria",
    "urgency": "Urgency",
    "routine": "routine",
    "urgent": "urgent",
    "emergent": "emergent",
    "every2weeks": "Every 2 weeks",
    "every3weeks": "Every 3 weeks",
    "every4weeks": "Every 4 weeks (Monthly)",
    "every6weeks": "Every 6 weeks",
    "ongoingWellness": "Ongoing wellness care",
    "selfLimiting": "Self-limiting condition",
    "expectedTimeline": "Expected timeline",
    "evidence": {
      "levelA": "Level A: Strong",
      "levelB": "Level B: Moderate",
      "levelC": "Level C: Limited"
    },
    "loadingSupplements": "Loading supplements...",
    "exerciseProgrammePdf": "Exercise Programme PDF",
    "generated": "Generated",
    "infantGoals": "Treatment Goals for Your Baby",
    "treatmentsConcurrent": "treatments run concurrently",
    "clinicianOverride": "Clinician Override",
    "scheduleDescription": "Treatment protocols reviewed against latest clinical evidence. Adjust the schedule below as needed.",
    "visitsPerWeek": "visits/week",
    "for": "for",
    "weeks": "Weeks",
    "visits": "visits",
    "phase3Ongoing": "Maintenance",
    "reExamSchedule": "Re-examination Schedule",
    "reExamsAtWeek": "Re-exams at week",
    "addReExamWeek": "Add re-exam week",
    "removeLastReExam": "Remove last re-exam",
    "scheduleSummary": "Blocks 1+2: ~{{totalVisits}} visits over ~{{totalWeeks}} weeks + Maintenance: every {{maintenanceWeeks}} weeks (ongoing)",
    "resetToDefaults": "Reset to Defaults",
    "whatDoesThisMean": "What does this mean?",
    "whatIsThis": "What is this?",
    "howDoesItHappen": "How does it happen?",
    "whatCanBeDone": "What can be done?",
    "whatToExpect": "What to expect",
    "whenToWorry": "When to worry",
    "do": "DO",
    "avoid": "AVOID",
    "contraindications": "Contraindications",
    "recommendedApproach": "Recommended Approach",
    "clinicServices": "Clinic Services",
    "noSupplementsYet": "No supplement recommendations generated yet. They are created automatically when you generate the management plan.",
    "grade": "Grade",
    "dosage": "Dosage",
    "timing": "Timing",
    "highSeverityWarning": "High-severity interaction detected. Consider disabling this supplement",
    "disableSupplement": "Disable supplement",
    "enableSupplement": "Enable supplement",
    "active": "active",
    "total": "total",
    "citations": "citations",
    "effect": "Effect",
    "evidenceLevelsDescription": "Evidence levels: A = High-quality RCTs/meta-analyses, B = Moderate-quality evidence, C = Expert consensus/case series",
    "failedToGenerate": "Failed to generate plan",
    "exercisePdfError": "Exercise PDF error",
    "downloadFailed": "Download failed",
    "goalLabels": {
      "pain_relief": "Pain relief",
      "return_to_sport": "Return to sport/activity",
      "improve_posture": "Improve posture",
      "prevent_recurrence": "Help reduce the risk of recurrence",
      "improve_mobility": "Improve mobility/flexibility",
      "manage_chronic": "Manage chronic condition",
      "pre_post_surgical": "Pre/post-surgical rehabilitation",
      "general_wellness": "General wellness",
      "symptom_resolution": "Symptom resolution",
      "improve_movement": "Improve movement & symmetry",
      "support_development": "Support developmental milestones",
      "feeding_comfort": "Improve feeding comfort",
      "sleep_improvement": "Improve sleep quality",
      "parent_confidence": "Build parent confidence",
      "head_shape": "Head shape improvement",
      "prevent_secondary": "Prevent secondary issues"
    },
    "regions": {
      "lumbar": "Lumbar (Lower Back)",
      "cervical": "Cervical (Neck)",
      "thoracic": "Thoracic (Mid Back)",
      "shoulder": "Shoulder",
      "knee": "Knee",
      "hip": "Hip",
      "elbow": "Elbow",
      "wrist": "Wrist/Hand",
      "ankle": "Ankle/Foot",
      "general": "General"
    },
    "visitWarning": {
      "title": "Visit count below typical pathway range",
      "body": "Planned visit count is below the typical pathway range for this severity. Consider whether the lower count is intentional (rapid response expected, patient preference, mild presentation) or if a brief reassessment plan would be appropriate.",
      "severity": {
        "mild": "mild",
        "moderate": "moderate",
        "moderateSevere": "moderate-severe",
        "severe": "severe"
      }
    },
    "severityTier": {
      "mildModerate": "Mild-Moderate",
      "moderate": "Moderate",
      "moderateSevere": "Moderate-Severe",
      "moderateHigh": "Moderate-High",
      "high": "High"
    },
    "moderateExplanation": "Your symptoms currently show a moderate level of overall impact because more than one area is involved and your highest reported pain score is 6/10. This does not mean anything dangerous was found, but it helps us plan care and monitor progress.",
    "reexamPoints": {
      "title": "Re-examinations",
      "add": "Add re-exam",
      "empty": "No re-examinations scheduled. Add one to anchor a formal progress re-check to a planned visit.",
      "visitOption": "Visit {{n}} (week {{w}})",
      "missingVisit": "Visit {{n}} (no longer planned)",
      "invalidWarning": "This visit no longer exists. It is excluded from the report until fixed.",
      "remove": "Remove"
    },
    "genericTemplate": "generic template",
    "genericTemplateHint": "No condition-specific protocol is on file; this is the generic 3-phase template."
  },
  "report": {
    "title": "Clinical Report",
    "generate": "Generate Report",
    "regenerate": "Regenerate",
    "format": "Report Format",
    "compact": "Compact",
    "comprehensive": "Comprehensive",
    "selectLanguage": "Report Language",
    "selectSections": "Sections to Include",
    "printReport": "Print Report",
    "downloadPdf": "Download PDF",
    "generatedOn": "Generated on",
    "disclaimer": "This report contains working hypotheses for clinical consideration only. It does not constitute a definitive diagnosis.",
    "includeLetterhead": "Include clinic letterhead",
    "enhanceWithAi": "Enhance with AI",
    "selectAtLeastOne": "Select at least one section",
    "aiSummary": "AI-Enhanced Summary (Optional)",
    "dismiss": "Dismiss",
    "keyPoints": "Key Points",
    "nextSteps": "Recommended Next Steps",
    "clinicalReport": "Clinical Assessment Report",
    "compactReport": "compact report",
    "comprehensiveReport": "comprehensive report",
    "bookAppointment": "Book Your Next Appointment",
    "callUs": "Call us:",
    "emailUs": "Email:",
    "visitUs": "Visit:",
    "openingHours": "Opening hours:",
    "followInstagram": "Follow us on Instagram:",
    "scanToBook": "Scan to book your next appointment",
    "confidential": "Confidential",
    "was": "Was",
    "now": "Now",
    "before": "Before",
    "better": "better",
    "improvement": "improvement",
    "outcomeMeasureDeltas": "Outcome Measure Deltas",
    "outcomeMeasureChanges": "Outcome Measure Changes",
    "measure": "Measure",
    "change": "Change",
    "significance": "Significance",
    "whyOngoingCare": "Why Ongoing Care Matters",
    "painRelief": "Pain Relief",
    "rehabilitation": "Rehabilitation",
    "maintenance": "Wellness",
    "peakPerformance": "Peak Performance",
    "emailReport": "Email Report to Patient",
    "emailInstructions": "Enter the patient's email address to send them a copy of this report",
    "patientEmailOverride": "Patient Email (optional override)",
    "sendReport": "Send Report",
    "sending": "Sending...",
    "sections": {
      "patient_info": "Patient Information",
      "chief_complaints": "Chief Complaints",
      "medical_history": "Medical History",
      "examination_findings": "Examination Findings",
      "imaging_results": "Imaging Results",
      "diagnosis": "Diagnosis (DDx)",
      "treatment_plan": "Treatment Plan",
      "wellness_score": "Body Performance Score",
      "red_flags": "Red Flags",
      "referrals": "Referrals",
      "supplement_plan": "Supplement Recommendations"
    },
    "yourCarePathway": "The Road to Progress",
    "phase1PainRelief": "1. Relief Care",
    "phase1Desc": "Recovery phase: getting you out of pain",
    "phase2Rehab": "2. Rehabilitation",
    "phase2Desc": "Improvement phase: building your resilience",
    "phase3Wellness": "3. Wellness Care",
    "phase3Desc": "Optimization phase: keeping you at your peak",
    "didYouKnow": "Did You Know?",
    "didYouKnowText": "Regular check-ups can help us track your progress, identify changes in movement or function early, and support your self-management. For many patients, ongoing care is useful for staying active and reducing the likelihood of flare-ups.",
    "knowSomeone": "Know someone who could benefit?",
    "knowSomeoneText": "We'd love to help your family and friends too. If you know someone who could benefit from our care, we'd be honoured to welcome them.",
    "outOf100": "out of 100",
    "zone": "Zone",
    "treatmentGoals": "Your treatment goals:",
    "whenToContact": "When to Contact Us",
    "dearGuardianOf": "Parent/Guardian of",
    "dearPatient": "Dear",
    "thankYouBringing": "Thank you for bringing {name} to {clinic}. Below is a summary of our findings and recommended care plan.",
    "ongoingCareIntro": "Just like you visit the dentist every 6 months to keep your teeth healthy, your spine and musculoskeletal system benefit from regular check-ups. These visits help us catch small issues before they become big problems.",
    "evidenceCareParagraph": "Back pain and neck pain can improve, but symptoms can sometimes return, especially when work posture, stress, weakness, stiffness, training load, or lifestyle factors are not addressed. Research supports manual therapy, including spinal manipulation, as one option for low back pain when combined with exercise, rehabilitation, education, and self-management. For selected patients with recurrent or persistent low back pain who respond well to initial chiropractic care, maintenance care has been shown to reduce the number of bothersome low back pain days over 12 months compared with care only when symptoms return.",
    "evidenceCitation": "Based on: NICE Guideline NG59; Eklund et al. (2018) Nordic Maintenance Care RCT; Senna & Machaly (2011) Spine; Cochrane Review CD008112 (Rubinstein et al.).",
    "encourageWellness": "We encourage regular wellness check-ups even after your symptoms have resolved. Your musculoskeletal health is an ongoing journey, and we are here to support you every step of the way.",
    "versionHistory": "Amendment history",
    "supersededBanner": "You are viewing a superseded version. It is read only.",
    "versionLabel": "Version",
    "versionCurrent": "current",
    "versionSuperseded": "superseded",
    "notReadyTitle": "This report is not ready yet",
    "notReadyBody": "The assessment does not yet have enough recorded to produce a patient report. Complete the remaining steps, then open the report again."
  },
  "soap": {
    "title": "SOAP Note",
    "printView": "SOAP Note: Print View",
    "loading": "Loading SOAP note...",
    "autoGenerate": "Auto-Generate",
    "aiPolish": "AI Polish",
    "aiPolishing": "AI Polishing...",
    "backToEditor": "Back to Editor",
    "saveNote": "Save SOAP Note",
    "saving": "Saving...",
    "savedSuccess": "SOAP note saved successfully.",
    "autoGenerated": "Note auto-generated from assessment data.",
    "subjective": "Subjective",
    "objective": "Objective (Findings & Working Hypotheses)",
    "assessment": "Action / Treatment Delivered",
    "plan": "Plan",
    "subjectivePlaceholder": "Patient-reported symptoms, history, and complaints...",
    "objectivePlaceholder": "Examination findings, DDx working hypotheses, BPS score...",
    "assessmentPlaceholder": "e.g., CMT C4-5 R rotation, grade IV mob L4-5, STT upper traps B, neural mobilisation...",
    "planPlaceholder": "Treatment plan, follow-up, referrals, patient education...",
    "formatting": "Formatting:",
    "errors": {
      "generateFailed": "Failed to generate SOAP note",
      "saveFailed": "Failed to save SOAP note"
    }
  },
  "settings": {
    "title": "Clinic Settings",
    "manageDesc": "Manage your clinic branding and information",
    "viewDesc": "View clinic information",
    "clinicInfo": "Clinic Information",
    "clinicName": "Clinic Name",
    "phone": "Phone",
    "email": "Email",
    "website": "Website",
    "address": "Address",
    "instagram": "Instagram Handle",
    "openingHours": "Opening Hours",
    "clinicLogo": "Clinic Logo",
    "logoDesc": "Upload your clinic logo. It will appear in the app header, login page, and reports. Accepted formats: PNG, JPG, SVG. Max 2MB.",
    "uploading": "Uploading…",
    "uploadLogo": "Upload Logo",
    "removeLogo": "Remove logo",
    "branding": "Branding",
    "primaryColor": "Primary Color",
    "usedInHeaders": "Used in report headers",
    "reportFooter": "Report Footer Text",
    "qrCodeUrl": "QR Code URL (for reports)",
    "qrCodeDesc": "Paste a booking link, Instagram page, or Google Maps link. A QR code will appear in patient reports.",
    "saveClinicInfo": "Save Clinic Info",
    "aiConfig": "AI Configuration",
    "aiConfigDesc": "Configure an external AI API for clinical analysis features like DDx second opinion, SOAP note generation, and imaging analysis.",
    "aiProvider": "AI Provider",
    "model": "Model",
    "enterModel": "Enter model name",
    "apiKey": "API Key",
    "currentKeyMasked": "Current key: [masked]. Leave blank to keep current key",
    "apiEndpoint": "API Endpoint",
    "monthlyBudget": "Monthly Budget Limit (optional)",
    "noLimit": "No limit",
    "perMonth": "/ month (informational)",
    "saveAiConfig": "Save AI Config",
    "testConnection": "Test Connection",
    "testing": "Testing…",
    "emailConfig": "Email Configuration (SMTP)",
    "emailConfigDesc": "Configure SMTP to send patient reports via email directly from the platform. Your SMTP password is stored encrypted.",
    "enableEmail": "Enable email sending",
    "smtpHost": "SMTP Host",
    "smtpPort": "SMTP Port",
    "smtpPortWarning465": "Port 465 may be blocked by some hosting providers. If emails fail, switch to port 587 (STARTTLS).",
    "smtpUser": "SMTP Username",
    "smtpPassword": "SMTP Password",
    "smtpFrom": "From Email Address",
    "saveSmtpConfig": "Save SMTP Config",
    "tabClinicSettings": "Clinic Settings",
    "tabTreatmentProtocols": "Treatment Protocols",
    "navIdentity": "Clinic Identity",
    "navTeam": "Your Team",
    "navModalities": "Modalities",
    "navTools": "Assessment Tools",
    "navPathway": "Care Pathway",
    "navReports": "Reports",
    "navChecker": "Symptom Checker",
    "navIntegrations": "Integrations",
    "navType": "Clinic Type",
    "navBilling": "Billing",
    "whatsappNumber": "WhatsApp Number",
    "googleMapsLink": "Google Maps Link",
    "facebook": "Facebook",
    "linkedin": "LinkedIn",
    "regionalSettings": "Regional Settings",
    "dateFormat": "Date Format",
    "dateFmtEU": "DD/MM/YYYY (EU/Cyprus)",
    "dateFmtUS": "MM/DD/YYYY (US)",
    "dateFmtISO": "YYYY-MM-DD (ISO)",
    "measurementSystem": "Measurement System",
    "measureMetric": "Metric (cm, kg)",
    "measureImperial": "Imperial (in, lb)",
    "customNextSteps": "Custom Next Steps",
    "customNextStepsDesc": "Customise the \"Next Steps\" section of patient reports with your own message and image.",
    "customMessage": "Custom Message",
    "generateWithAi": "Generate with AI",
    "nextStepsImage": "Next Steps Image (optional)",
    "nextStepsImageDesc": "Upload an image to display in the Next Steps section of patient reports. Max 1MB.",
    "removeImage": "Remove Image",
    "reportContent": "Report Content",
    "reportContentDesc": "Customise the text that appears in the patient report sections below.",
    "aboutOurTeam": "About Our Team",
    "treatmentApproach": "Treatment Approach",
    "maintenanceWellnessMsg": "Maintenance / Wellness Message",
    "yourTeam": "Your Team",
    "addMember": "+ Add Member",
    "teamDesc": "These team members appear in the Patient Report under \"Your Care Team\". The Lead Clinician signs reports.",
    "fullName": "Full Name *",
    "roleTitle": "Role / Title at Clinic *",
    "professionalCredential": "Professional Credential",
    "selectCredential": "Select credential",
    "displayOnReports": "Display on reports",
    "displayPrefNameCred": "Name (Credential), default",
    "displayPrefNameOnly": "Name only",
    "displayPrefCustom": "Custom: free text",
    "customTitlePlaceholder": "Exactly how you want your name to appear on reports",
    "preview": "Preview:",
    "shortBio": "Short Bio",
    "shortBioPlaceholder": "Brief professional bio shown in patient reports (max 600 chars)",
    "leadClinician": "Lead / Owner Clinician",
    "leadClinicianNote": "(signs reports, only one per clinic)",
    "lead": "Lead",
    "noTeamMembers": "No team members configured. Click \"Add Member\" to get started.",
    "saveModalities": "Save Modalities",
    "saveAllChanges": "Save All Changes",
    "saveAssessmentTools": "Save Assessment Tools",
    "saveCarePathway": "Save Care Pathway",
    "saveReportPreferences": "Save Report Preferences",
    "reportTemplates": "Report Templates",
    "reportTemplatesDesc": "Design and customise the layout of patient reports.",
    "aiCredits": "AI Credits",
    "mskCredits": "MSK Credits",
    "ownApiKey": "Own API Key",
    "aiCreditsDesc": "Choose how AI features are powered.",
    "aiMode": "AI Mode",
    "useOwnApiKey": "Use your own API key",
    "useMskCredits": "Use MSK Insight AI Credits",
    "creditBalance": "Credit Balance",
    "creditRateFast": "Fast call = 1 credit",
    "creditRateSmart": "Smart call = 5 credits",
    "creditRateFormat": "Format call = 1 credit",
    "lowCreditsWarning": "Low credits! AI features may stop working soon. Please purchase more credits.",
    "creditPacks": "Credit Packs",
    "buyCredits": "Buy Credits",
    "buyCreditsNote": "Contact support@mskinsight.com to purchase",
    "googleReviews": "Google Reviews",
    "connected": "Connected",
    "notConnected": "Not connected",
    "googleReviewsDesc": "Connect your Google Business review link to send review requests to patients via email or WhatsApp.",
    "googleReviewUrlLabel": "Google Review URL",
    "googleReviewUrlHint": "Find your link in Google Business Profile under \"Get more reviews\"",
    "saveReviewUrl": "Save Review URL",
    "whatsappBusiness": "WhatsApp Business",
    "notConfigured": "Not configured",
    "whatsappBusinessDesc": "Configure your WhatsApp Business number and message template for patient communications.",
    "whatsappBusinessNumber": "WhatsApp Business Number",
    "whatsappNumberHint": "Include country code (e.g. +357 for Cyprus, +44 for UK)",
    "defaultMsgTemplate": "Default Message Template",
    "templateVariables": "Available variables: {patientName}, {clinicName}, {condition}, {reviewUrl}",
    "saveWhatsappSettings": "Save WhatsApp Settings",
    "testWhatsapp": "Test WhatsApp",
    "saveClinicType": "Save Clinic Type",
    "demoMode": "Demo Mode",
    "demoModeDesc": "Load sample data for demonstrations. No real patient data will be visible.",
    "demoModeOn": "Demo mode is ON. Real patient data is hidden",
    "modalities": {
      "title": "Clinical Modalities",
      "helperText": "Select the treatment modalities your clinic offers. AI recommendations and patient reports will be aligned to these.",
      "clinicNotesHint": "Add a private clinic note for this modality",
      "clinicNotesPlaceholder": "Optional clinic notes (visible only to clinicians, not patients)",
      "customGroupLabel": "Custom modalities (clinic-specific)",
      "removeCustom": "Remove custom modality",
      "addCustomTitle": "Add a custom modality",
      "addCustomPlaceholder": "e.g. Cryotherapy chamber",
      "addCustomButton": "Add",
      "filledSummary": "{{count}} of {{total}} modalities enabled",
      "groups": {
        "manual": {
          "label": "Manual Therapy"
        },
        "active": {
          "label": "Active Therapy"
        },
        "modality_based": {
          "label": "Modality-Based"
        },
        "education": {
          "label": "Education / Lifestyle"
        }
      },
      "items": {
        "spinal_manipulation": {
          "label": "Spinal manipulation / HVLA",
          "description": "High-velocity, low-amplitude spinal adjustment delivered by hand."
        },
        "instrument_adjusting": {
          "label": "Instrument-assisted (Pulstar / Activator)",
          "description": "Mechanical adjusting using a percussion or impulse tool such as Pulstar or Activator."
        },
        "drop_piece": {
          "label": "Drop-piece technique",
          "description": "Articulating table segments that drop on impact to assist segmental adjusting."
        },
        "soft_tissue": {
          "label": "Soft tissue therapy / MFR",
          "description": "Manual soft-tissue release including myofascial techniques."
        },
        "iastm": {
          "label": "IASTM (Graston / FAKTR)",
          "description": "Instrument-assisted soft tissue mobilisation using Graston, FAKTR or similar tools."
        },
        "dry_needling": {
          "label": "Dry needling",
          "description": "Trigger-point needling for myofascial pain and motor-end-plate dysfunction."
        },
        "cupping": {
          "label": "Cupping",
          "description": "Decompressive suction therapy applied to skin and underlying fascia."
        },
        "neural_mobilisation": {
          "label": "Neural mobilisation",
          "description": "Sliders and tensioners to mobilise neural tissue along its anatomical course."
        },
        "joint_mobilisation": {
          "label": "Joint mobilisation (Maitland)",
          "description": "Graded oscillatory mobilisation per the Maitland framework."
        },
        "rehab_exercises": {
          "label": "Rehabilitation exercises",
          "description": "Prescribed corrective and strengthening exercise programmes."
        },
        "functional_movement": {
          "label": "Functional movement screening",
          "description": "Standardised movement screens to identify dysfunctional patterns."
        },
        "clinical_pilates": {
          "label": "Clinical Pilates",
          "description": "Pilates principles adapted for rehabilitation and motor control."
        },
        "gait_retraining": {
          "label": "Gait retraining",
          "description": "Cueing and exercise to restore an efficient walking or running pattern."
        },
        "neuromuscular_reeducation": {
          "label": "Neuromuscular re-education",
          "description": "Drills that restore coordinated muscle activation and timing."
        },
        "breathing_exercises": {
          "label": "Breathing / diaphragm training",
          "description": "Diaphragmatic and breath-pattern training for postural and pain control."
        },
        "spinal_decompression": {
          "label": "Spinal decompression (DOC table)",
          "description": "Mechanical traction (DOC table or similar) for disc-related radicular pain."
        },
        "shockwave": {
          "label": "Shockwave therapy (ESWT)",
          "description": "Extracorporeal shockwave therapy for tendinopathy and chronic soft tissue."
        },
        "laser": {
          "label": "Class IV laser",
          "description": "Class IV photobiomodulation for inflammation, pain and tissue repair."
        },
        "tens": {
          "label": "TENS / IFC",
          "description": "Transcutaneous electrical nerve stimulation or interferential current for pain."
        },
        "ultrasound": {
          "label": "Therapeutic ultrasound",
          "description": "Therapeutic ultrasound for soft-tissue heating and acoustic micromassage."
        },
        "kinesio_taping": {
          "label": "Kinesiology taping",
          "description": "Elastic therapeutic taping for proprioceptive and lymphatic effects."
        },
        "rigid_taping": {
          "label": "Rigid taping",
          "description": "Rigid athletic taping for joint support and movement restriction."
        },
        "normatec": {
          "label": "Normatec / compression therapy",
          "description": "Dynamic pneumatic compression for recovery and lymphatic drainage."
        },
        "heat_therapy": {
          "label": "Heat / cold therapy",
          "description": "Local heat or cold packs applied as an adjunct to manual care."
        },
        "hydrotherapy": {
          "label": "Hydrotherapy",
          "description": "Aquatic exercise and immersion-based rehabilitation."
        },
        "red_light_therapy": {
          "label": "Red light therapy",
          "description": "Low-level red and near-infrared light for tissue recovery and inflammation."
        },
        "posture_analysis": {
          "label": "Posture analysis",
          "description": "Static and dynamic posture assessment with photographic documentation."
        },
        "patient_education": {
          "label": "Patient education / advice",
          "description": "One-to-one advice on activity modification, ergonomics and self-care."
        },
        "ergonomic_assessment": {
          "label": "Ergonomic assessment",
          "description": "Workstation and daily-task assessment to reduce postural load."
        },
        "nutritional": {
          "label": "Nutritional / lifestyle counselling",
          "description": "Brief lifestyle and nutritional counselling within scope of practice."
        }
      },
      "primaryDiscipline": {
        "title": "Primary Discipline",
        "helperText": "Choose the discipline that best describes your clinic. This affects recommendation language, default modalities, and GP letter formatting.",
        "options": {
          "chiropractic": {
            "label": "Chiropractic",
            "description": "Spinal manipulation, adjustments, and neuromusculoskeletal care."
          },
          "physiotherapy": {
            "label": "Physiotherapy",
            "description": "Exercise-based rehabilitation, manual therapy, and movement science."
          },
          "osteopathy": {
            "label": "Osteopathy",
            "description": "Osteopathic manipulation and holistic musculoskeletal care."
          },
          "sports_medicine": {
            "label": "Sports Medicine",
            "description": "Sports injury treatment, performance optimisation, and return-to-play."
          },
          "multidisciplinary": {
            "label": "General MSK & Multidisciplinary",
            "description": "Multi-practitioner clinic covering various MSK disciplines."
          }
        }
      }
    },
    "navDiagnosticEquipment": "Diagnostic Equipment",
    "navOutcomeMeasuresAndTests": "Outcome Measures & Tests",
    "diagnosticEquipment": {
      "title": "Diagnostic Equipment",
      "subtitle": "Select the diagnostic and assessment tools available at your clinic."
    },
    "outcomeMeasuresAndTests": {
      "title": "Outcome Measures & Tests",
      "helperText": "Select which patient-reported outcome measures and orthopaedic test packs your clinic uses. AI suggestions and assessment workflows will be aligned to these."
    },
    "outcomeMeasures": {
      "sectionTitle": "Outcome Measures",
      "sectionSubtitle": "12 validated patient-reported instruments. Disabled measures will not be suggested in assessment workflows.",
      "filledSummary": "{{count}} of {{total}} outcome measures enabled",
      "groups": {
        "generic": {
          "label": "Generic"
        },
        "region_specific": {
          "label": "Region-specific"
        },
        "psychosocial": {
          "label": "Psychosocial screening"
        }
      },
      "items": {
        "PSFS": {
          "label": "Patient-Specific Functional Scale",
          "description": "Patient identifies 3-5 activities limited by their condition; rates ability 0-10."
        },
        "NPRS": {
          "label": "Numeric Pain Rating Scale",
          "description": "Single-item pain rating 0-10. Quick, universally understood."
        },
        "VAS": {
          "label": "Visual Analog Scale",
          "description": "Continuous 0-100mm line for pain or other subjective measures."
        },
        "GROC": {
          "label": "Global Rating of Change",
          "description": "Single retrospective rating of overall change since baseline."
        },
        "NDI": {
          "label": "Neck Disability Index",
          "description": "10-item disability index for cervical conditions. Score 0-50; MCID 5."
        },
        "ODI": {
          "label": "Oswestry Disability Index",
          "description": "10-item disability index for low back pain. Score 0-100; MCID 6."
        },
        "DASH": {
          "label": "DASH: Upper Limb Disability",
          "description": "Disabilities of the Arm, Shoulder and Hand. 30-item scale."
        },
        "LEFS": {
          "label": "Lower Extremity Functional Scale",
          "description": "20-item functional rating for lower-extremity musculoskeletal conditions."
        },
        "PHQ9": {
          "label": "Patient Health Questionnaire-9",
          "description": "Depression severity screen. Score 0-27."
        },
        "GAD7": {
          "label": "Generalised Anxiety Disorder-7",
          "description": "Anxiety severity screen. Score 0-21."
        },
        "STarT_Back": {
          "label": "STarT Back Screening Tool",
          "description": "9-item back pain risk stratification (low / medium / high risk)."
        },
        "TSK11": {
          "label": "Tampa Scale Kinesiophobia-11",
          "description": "11-item fear-of-movement scale. Score 11-44."
        }
      }
    },
    "orthopaedicTestPacks": {
      "sectionTitle": "Orthopaedic Test Packs",
      "sectionSubtitle": "14 region-grouped test packs. Each pack enables a curated set of orthopaedic tests in the assessment workflow.",
      "testCount": "{{count}} tests",
      "filledSummary": "{{count}} of {{total}} packs enabled ({{tests}} tests available)",
      "groups": {
        "axial": {
          "label": "Axial"
        },
        "upper_extremity": {
          "label": "Upper extremity"
        },
        "lower_extremity": {
          "label": "Lower extremity"
        },
        "special": {
          "label": "Special"
        }
      },
      "items": {
        "CERVICAL": {
          "label": "Cervical",
          "description": "Spurling's, distraction, ULTT, vertebral artery screen, and 11 others."
        },
        "THORACIC": {
          "label": "Thoracic",
          "description": "Spring testing, Adam's forward bend, costovertebral joint tests."
        },
        "LUMBAR": {
          "label": "Lumbar",
          "description": "SLR, slump, prone instability, Kemp's, and 16 others."
        },
        "SI_JOINT": {
          "label": "SI Joint",
          "description": "Cluster of 5 SIJ provocation tests (distraction, compression, thigh thrust, Gaenslen's, sacral thrust)."
        },
        "SACRAL": {
          "label": "Sacral",
          "description": "Sacral motion palpation, sacrococcygeal provocation, coccygeal mobility."
        },
        "HEADACHE": {
          "label": "Headache",
          "description": "Cervicogenic + tension-type headache provocation tests."
        },
        "SHOULDER": {
          "label": "Shoulder",
          "description": "Neer, Hawkins-Kennedy, Empty Can, O'Brien, apprehension, and 15 others."
        },
        "ELBOW": {
          "label": "Elbow",
          "description": "Cozen's, Mill's, ligament stress tests, Tinel's, and others."
        },
        "WRIST_HAND": {
          "label": "Wrist / Hand",
          "description": "Phalen's, Tinel's at wrist, Finkelstein, scaphoid tests, and others."
        },
        "HIP": {
          "label": "Hip",
          "description": "FABER, FADIR, Trendelenburg, Thomas test, and 8 others."
        },
        "KNEE": {
          "label": "Knee",
          "description": "Lachman, anterior drawer, McMurray, valgus/varus stress, and 15 others."
        },
        "ANKLE_FOOT": {
          "label": "Ankle / Foot",
          "description": "Anterior drawer, talar tilt, Thompson, syndesmosis tests, and others."
        },
        "DIZZINESS": {
          "label": "Dizziness",
          "description": "Dix-Hallpike, vestibular ocular motor screening, cervical screen."
        },
        "PAEDIATRIC": {
          "label": "Paediatric",
          "description": "26 paediatric-specific screens covering gait, posture, joint hypermobility, and developmental milestones."
        }
      }
    },
    "carePathway": {
      "title": "Care Pathway Defaults",
      "description": "Configure care phases with frequency and duration ranges, severity presets, and re-examination rules.",
      "phaseHeading": "Phase",
      "phaseName": "Phase Name",
      "subtitle": "Subtitle",
      "frequency": "Frequency",
      "frequencyTo": "to",
      "visitsPer": "visits per",
      "duration": "Duration",
      "weeks": "weeks",
      "ongoing": "Ongoing",
      "frequencyBlocks": "Frequency Blocks",
      "frequencyBlocksHint": "(optional, used for visit schedule generation)",
      "blockThen": "then",
      "blockFor": "for",
      "addFrequencyBlock": "+ Add frequency block",
      "goals": "Goals",
      "goalPlaceholder": "Enter goal...",
      "addGoal": "+ Add goal",
      "patientMessage": "Patient Message",
      "patientMessagePlaceholder": "Message shown to patients in reports...",
      "remove": "Remove",
      "addPhase": "+ Add Phase",
      "severityPresets": "Severity Presets",
      "severityMild": "Mild",
      "severityModerate": "Moderate",
      "severitySevere": "Severe",
      "severityFor": "for",
      "severityWk": "wk",
      "reExamRules": "Re-exam Rules",
      "firstReExamAfter": "First re-exam after",
      "thenEvery": "Then every",
      "visits": "visits",
      "customRule": "Custom Rule (optional)",
      "customRulePlaceholder": "e.g., Always re-exam after school holidays",
      "terminology": "Terminology Preference",
      "wellnessCare": "Wellness Care",
      "maintenanceCare": "Maintenance Care",
      "livePreview": "Live Preview",
      "previewLabel": "Preview",
      "reExam": "Re-exam:",
      "reExamSentence": "We'll review your progress after {{firstMin}}-{{firstMax}} visits, then every {{recMin}}-{{recMax}} visits.",
      "periodWeek": "week",
      "periodFortnight": "fortnight",
      "periodMonth": "month"
    },
    "checker": {
      "sectionTitle": "Symptom Checker",
      "sectionDescription": "Your public symptom checker page for patients and ad campaigns.",
      "statusLive": "LIVE",
      "statusNotActivated": "Not Activated",
      "preview": "Preview",
      "copy": "Copy",
      "copied": "Copied!",
      "adCampaignTitle": "Ad Campaign URLs",
      "adCampaignDescription": "Use these URLs in your Facebook, Google, and Instagram ads to direct patients to the symptom checker in the right language and body region.",
      "enableAtLeastOne": "Enable at least one language in Checker Customisation below.",
      "baseUrl": "Base URL",
      "copyAll": "Copy All",
      "regionLumbar": "Back Pain",
      "regionCervical": "Neck Pain",
      "regionShoulder": "Shoulder",
      "regionKnee": "Knee",
      "customisationTitle": "Checker Customisation",
      "customisationDescription": "Configure languages, display options, and tracking for your symptom checker.",
      "languages": "Languages",
      "defaultLanguage": "Default Language",
      "displayOptions": "Display Options",
      "showConfidence": "Show confidence score",
      "showClinicalTerms": "Show clinical terms",
      "showShareButton": "Show share button",
      "showDisclaimer": "Show disclaimer",
      "customDisclaimer": "Custom Disclaimer",
      "customDisclaimerPlaceholder": "Leave blank to use the default disclaimer",
      "whatsappTemplate": "WhatsApp Message Template",
      "whatsappTemplateHint": "Use {{conditionPh}} and {{regionPh}} as placeholders.",
      "gaId": "Google Analytics ID",
      "fbPixelId": "Facebook Pixel ID",
      "bookingButtonsTitle": "Booking Buttons",
      "bookingButtonsDescription": "Choose which contact buttons appear on the checker results page.",
      "showBookOnline": "Show \"Book Online\" button",
      "showBookOnlineNoUrl": "Show \"Book Online\" button (no booking URL set)",
      "showWhatsapp": "Show \"WhatsApp\" button",
      "showWhatsappNoNumber": "Show \"WhatsApp\" button (no WhatsApp number set)",
      "showCall": "Show \"Call\" button",
      "showCallNoPhone": "Show \"Call\" button (no phone number set)",
      "usageTitle": "Usage",
      "usageLoading": "Loading usage data...",
      "usageUnableToLoad": "Unable to load usage data.",
      "usageChecksThisMonth": "checks this month",
      "usageUnlimited": "(Unlimited)",
      "saveButton": "Save Checker Settings",
      "saving": "Saving..."
    },
    "reportPreferences": {
      "title": "Report & GP Letter Preferences",
      "description": "Configure report content, languages, and GP letter formatting.",
      "reportLanguages": "Report Languages",
      "defaultReportLanguage": "Default Report Language",
      "reportContentHeading": "Patient Report Content",
      "includeTeam": "Include team section",
      "includeStatistics": "Include statistics/research section",
      "includeSupplements": "Include supplements section",
      "includeExercises": "Include exercise programme",
      "commonReferralSpecialists": "Common Referral Specialists (one per line)",
      "commonReferralSpecialistsPlaceholder": "Orthopaedic Surgeon\nNeurologist\nRheumatologist"
    },
    "navAuditLog": "Audit Log",
    "navPrivacy": "Data & Privacy",
    "navSecurity": "Security",
    "frontDeskModule": "Front Desk",
    "frontDeskModuleDesc": "Block-booking reconciliation, refill and DNA queues, confirmations and the shift handover. Appointment syncing continues whether this is on or off.",
    "practiceHub": "PracticeHub",
    "practiceHubDesc": "Patient sync and document management. Appointments and patient records are pulled from your PracticeHub account.",
    "enablePracticeHub": "Enable PracticeHub sync",
    "phBaseUrl": "PracticeHub base URL",
    "phApiKey": "API key",
    "phApiKeyPlaceholder": "Enter API key",
    "phApiKeyFingerprint": "Key fingerprint: {{fp}}. Leave blank to keep",
    "phApiKeyIsV3": "This is a new-API (phk_) key. MSK Insight does not use these yet; keep it for the upcoming v3 connection.",
    "phSavedKeyAccepted": "Saved. PracticeHub accepted the key ({{patients}} patient records visible).",
    "phSavedKeyRefused": "Saved, but PracticeHub refused it. Check that you copied the whole key from PracticeHub.",
    "phSavedKeyRateLimited": "Saved, but PracticeHub is limiting requests right now. Press Test connection in a few minutes.",
    "phSavedKeyUntested": "Saved, but PracticeHub could not be reached to test it. Press Test connection.",
    "phAppDetails": "App details",
    "phAppDetailsHint": "The application name PracticeHub shows against this connection.",
    "savePracticeHubConfig": "Save PracticeHub config",
    "phTestOk": "Connected: {{patients}} patient record(s) visible.",
    "phTestOkNoCount": "Connected.",
    "phTestFailed": "Connection test failed",
    "phSaved": "PracticeHub configuration saved.",
    "phSaveFailed": "Failed to save the PracticeHub configuration."
  },
  "audit": {
    "title": "Audit Log",
    "dateFrom": "Date From",
    "dateTo": "Date To",
    "user": "User",
    "searchByName": "Search by name...",
    "action": "Action",
    "entity": "Entity",
    "applyFilters": "Apply Filters",
    "recordsFound": "{{count}} record(s) found",
    "noEntries": "No audit log entries found matching the current filters.",
    "table": {
      "timestamp": "Timestamp",
      "user": "User",
      "action": "Action",
      "entity": "Entity",
      "details": "Details"
    },
    "page": "Page {{current}} of {{total}}",
    "actions": {
      "all": "All Actions",
      "create": "Create",
      "read": "Read",
      "update": "Update",
      "delete": "Delete",
      "login": "Login",
      "logout": "Logout",
      "export": "Export",
      "consent": "Consent"
    },
    "entities": {
      "all": "All Entities",
      "patient": "Patient",
      "assessment": "Assessment",
      "user": "User",
      "consent": "Consent",
      "report": "Report",
      "referral": "Referral"
    }
  },
  "gdpr": {
    "title": "GDPR & Data Privacy",
    "description": "Manage patient data rights including export, deletion, and anonymization in compliance with GDPR.",
    "findPatient": "Find Patient",
    "searchPlaceholder": "Search by name, email, or patient ID...",
    "searching": "Searching...",
    "selectedPatient": "Selected Patient",
    "dataExport": "Data Export",
    "exportDesc": "Export all patient data as a JSON file. This includes personal information, assessments, consents, and clinical records.",
    "exporting": "Exporting...",
    "exportButton": "Export Patient Data (JSON)",
    "rightToForget": "Right to be Forgotten",
    "rightToForgetDesc": "Permanently delete all patient data. This action is irreversible and will be scheduled with a grace period.",
    "requestDeletion": "Request Data Deletion",
    "typeDeleteConfirm": "Type DELETE to confirm permanent deletion:",
    "processing": "Processing...",
    "confirmDelete": "Confirm Delete",
    "anonymization": "Anonymization",
    "anonymizationDesc": "Remove personal identifiers while preserving clinical data for research and analytics purposes.",
    "anonymizeButton": "Anonymize Patient Data",
    "anonymizeWarning": "This will remove all personal identifiers. Clinical data will be retained anonymously.",
    "confirmAnonymize": "Confirm Anonymize",
    "consentOverview": "Data Processing Consent Overview",
    "noConsent": "No consent records found for this patient.",
    "consentTable": {
      "type": "Consent Type",
      "status": "Status",
      "lastUpdated": "Last Updated"
    }
  },
  "wizard": {
    "stepNames": {
      "1": "Chief Complaints",
      "2": "Medical History",
      "3": "Physical Examination",
      "4": "Posture Analysis",
      "5": "Investigations",
      "6": "Outcome Measures",
      "7": "DDx Review",
      "8": "Management Plan",
      "9": "Report Generation"
    },
    "fullAssessment": "Full Assessment",
    "quickScore": "Quick Score",
    "reExamination": "Re-Examination",
    "stepOf": "Step {{current}} of {{total}}",
    "paediatric": "Paediatric",
    "finalized": "Finalized",
    "savedAt": "Saved {{time}}",
    "saveAndExit": "Save & Exit",
    "aiAnalysingImages": "AI analysing {{count}} image",
    "saveAndContinueTo": "Save & Continue to {{stepName}} →",
    "saveAndContinue": "Save & Continue →",
    "previousSection": "← Previous Section",
    "completeAssessment": "✓ Complete Assessment",
    "optional": "Optional",
    "loadingAssessment": "Loading assessment…",
    "goBack": "Go back",
    "noPatientSelected": "No patient selected. Start an assessment from a patient's profile.",
    "viewPatients": "View Patients",
    "saveAsDraft": "💾 Save as Draft: Front Desk Will Complete",
    "continueToReport": "Continue to Report Generation →",
    "finalizeReport": "Finalize Report",
    "finalizeReady": "Once all sections are ready, finalize the report to mark it complete.",
    "reportFinalized": "Report finalized and ready for patient.",
    "step": "Step",
    "of": "of",
    "stepComingSoon": "Step {{step}}: content coming soon.",
    "saveDraft": "Save Draft",
    "validation": {
      "complaintsRequired": "Please add at least one complaint before continuing."
    },
    "finalizeErrorTitle": "Finalize did not complete.",
    "finalizeAlreadyIssued": "This report has already been issued. Reopen it for amendment to publish a new version.",
    "finalizeNotAuthor": "Only the clinician who issued this report can amend it.",
    "finalizeFailed": "Nothing was saved. Please try again.",
    "noFrequency": {
      "title": "No treatment frequency set",
      "body": "This plan has no treatment frequency blocks, so the report would have no visit schedule.",
      "applyDefault": "Apply {{preset}} and complete",
      "completeAnyway": "Complete without a frequency plan",
      "presetMissing": "The default preset could not be loaded. Set the frequency in the Management Plan step.",
      "lowVisitsTitle": "This plan has {{count}} active visit(s). Issue anyway?",
      "lowVisitsBody": "A plan this short is not a course of care, so the report will not estimate a completion time. You can apply a preset first, or issue as it is.",
      "noPresetTitle": "No preset was applied to this plan. Issue anyway?",
      "noPresetBody": "Without a preset the report will not estimate a completion time. You can apply the clinic's default preset first, or issue as it is.",
      "issueAnyway": "Issue anyway"
    }
  },
  "patientReport": {
    "dear": "Dear",
    "introP1": "Thank you for choosing {{clinicName}} for your care. Following your thorough assessment, we are pleased to share this personalised report with you. It explains what we found, how we plan to help you, and what you can do at home to support your recovery. We want you to feel confident and informed every step of the way.",
    "introP2": "Our goal is not just to help you feel better, but to help you stay better. We are here to support you through every stage of your care journey.",
    "whatWeFound": "What We Found",
    "aiSummaryTitle": "Your Visit Summary",
    "whatWeFoundIntro": "Based on your history and examination, the findings are most consistent with the following working hypotheses. These describe patterns that may be contributing to your symptoms; they do not confirm one exact pain-generating structure and may be revised as we monitor your progress or receive new information. Your care plan is guided by your symptoms, function, examination findings, goals and response to care rather than by the label alone. Where appropriate, we will also recommend medical review or further investigation.",
    "whatIsIt": "What is it?",
    "howDoesItHappen": "How does it happen?",
    "whatCanBeDone": "What can be done?",
    "whatToExpect": "What to expect?",
    "whatDoesThisMean": "What does this mean?",
    "reExamDisclaimer": "Research suggests typical recovery timeframes and treatment frequencies for these conditions. We prefer to proceed with the suggested plan and re-examine your progress along the way. These re-exams help us compare how you were, how you are, and decide how we'll proceed together.",
    "yourProgress": "Your Progress",
    "yourTreatmentPlan": "Your Treatment Plan",
    "treatmentPlanIntro": "Your treatment is structured in phases, each designed to build on the progress of the previous one. Think of it as a journey from pain relief, through rehabilitation, to long-term wellness.",
    "expectedDuration": "Expected Duration",
    "treatmentsConcurrent": "(treatments for all conditions run concurrently)",
    "phase": "Phase",
    "duration": "Duration",
    "weeks": "weeks",
    "frequency": "Frequency",
    "phaseTableStage": "Care Stage",
    "phaseTableCondition": "Condition",
    "phaseTableFocus": "Focus",
    "phaseTableCadenceNote": "Visit cadence is shown in your treatment-frequency schedule below.",
    "techniques": "Techniques",
    "goals": "Goals",
    "goldenRulesTitle": "Your Golden Rules",
    "goldenRulesIntro": "These are the key things to remember between appointments. Following these guidelines will help you get the best results from your treatment.",
    "doNow": "Do Now",
    "thingsToAvoid": "Things to Avoid",
    "lifestyleChanges": "Lifestyle Changes",
    "homeCareTitle": "Home Care Advice",
    "supplementsTitle": "Recommended Supplements",
    "supplementsIntro": "These supplements are recommended based on your assessment to support your recovery. Always consult your GP or pharmacist before starting any new supplements, particularly if you take medication.",
    "supplement": "Supplement",
    "yourWellnessScore": "Your Body Performance Score",
    "wellnessScoreIntro": "Your Body Performance Score reflects multiple aspects of your musculoskeletal health. The chart below shows how each area is performing, and we will track improvements over time.",
    "overallScore": "Overall Score",
    "scoreExcellent": "Excellent. Keep up the great work!",
    "scoreGood": "Good. With targeted care you can reach your best.",
    "scoreFair": "Fair. There is room for improvement, and our plan is designed to help.",
    "scoreNeedsAttention": "Needs attention. Our treatment plan targets the areas that need the most help.",
    "exercisesTitle": "Recommended Exercises",
    "exerciseSets": "sets",
    "exerciseReps": "reps",
    "exerciseHold": "hold",
    "exerciseSec": "sec",
    "whyOngoingCare": "Why Ongoing Care Is Important",
    "ongoingCareP1": "Research consistently shows that patients who complete their full course of care, including the wellness phase, experience significantly better long-term outcomes. Stopping treatment when the pain subsides is like stopping antibiotics halfway through: the symptoms may be gone, but the underlying issue has not fully resolved.",
    "ongoingCareP2": "Your care pathway:",
    "carePhase1": "Relief Care: Reduce pain and inflammation",
    "carePhase2": "Rehabilitation: Restore strength and function",
    "carePhase3": "Wellness Care: Supporting long-term movement, function and self-management",
    "ongoingCareP3": "Patients who follow through to the wellness phase may experience fewer recurrences. We strongly recommend completing all phases of your treatment.",
    "yourCareTeam": "Your Care Team",
    "careTeamIntro": "You are in excellent hands. Our team of experienced practitioners is dedicated to helping you achieve the best possible outcome.",
    "nextSteps": "Next Steps",
    "nextStepsIntro": "Ready to begin your journey to better health? Book your next appointment today.",
    "phone": "Phone",
    "email": "Email",
    "website": "Website",
    "instagram": "Instagram",
    "footer": "This report is provided for educational purposes as part of your care plan. The conditions listed represent working hypotheses for clinical consideration only and should not be taken as definitive diagnoses. Please discuss any concerns with your treating practitioner.",
    "footerOneLine": "Educational summary. Conditions listed are working hypotheses for clinical consideration, not definitive diagnoses. Discuss any concerns with your practitioner.",
    "cta": {
      "whatsappLabel": "WhatsApp",
      "whatsappPrefix": "Message us on WhatsApp:",
      "referTitle": "Refer a Friend",
      "referHeading": "Know someone who could benefit from our care?",
      "referLine1": "We'd love to help your family and friends too.",
      "referLine2": "If you know someone who could benefit, we'd be honoured to welcome them.",
      "referShare": "Share",
      "googleReviewCtaTitle": "Help others find us",
      "googleReviewCtaBody": "If we've helped you, please consider leaving a 5-star Google review. It takes 30 seconds and helps people find quality care.",
      "googleReviewCtaButton": "Leave a Google review"
    }
  },
  "redFlags": {
    "title": "Red Flag Screening",
    "instructions": "Answer YES or NO to each screening question. These are asked once for the entire assessment.",
    "emergencyDetected": "MEDICAL EMERGENCY DETECTED",
    "emergencyMessage": "One or more medical emergencies have been identified. Review immediately and take appropriate action.",
    "flagsDetected": "Red Flags Detected",
    "emergencyAndFlags": "Emergency & Red Flags Detected",
    "emergencyInstruction": "STOP: Emergency flags must be addressed before any clinical procedures. All flags require clinician action before proceeding.",
    "flagsInstruction": "The following red flags require clinician action before proceeding.",
    "screeningComplete": "Red flag screening complete. No concerns requiring immediate action.",
    "backToReview": "← Back to Complaint Review",
    "reviewed": "Red flags reviewed. Use the bottom navigation to continue",
    "submitting": "Submitting...",
    "submitAndContinue": "Submit Screening & Continue →"
  },
  "statusBadges": {
    "draft": "Draft",
    "in_progress": "In Progress",
    "clinician_draft": "Awaiting Front Desk",
    "front_desk_review": "Front Desk Working",
    "completed": "Completed",
    "finalized": "Finalized"
  },
  "carePhases": {
    "initial": "Initial",
    "active": "Active Care",
    "maintenance": "Maintenance",
    "wellness": "Wellness"
  },
  "bodyRegions": {
    "headache": "Headache",
    "dizziness": "Dizziness",
    "cervical": "Cervical",
    "thoracic": "Thoracic",
    "lumbar": "Lumbar",
    "sacral": "Sacral",
    "shoulder_left": "L Shoulder",
    "shoulder_right": "R Shoulder",
    "elbow_left": "L Elbow",
    "elbow_right": "R Elbow",
    "wrist_hand_left": "L Wrist",
    "wrist_hand_right": "R Wrist",
    "hip_left": "L Hip",
    "hip_right": "R Hip",
    "knee_left": "L Knee",
    "knee_right": "R Knee",
    "ankle_foot_left": "L Ankle",
    "ankle_foot_right": "R Ankle",
    "tmj": "TMJ",
    "growing_pains": "Growing Pains",
    "torticollis": "Torticollis"
  },
  "infant": {
    "reportTitle": "Your Baby's Health Report",
    "progressUpdate": "Progress Update",
    "initialAssessment": "Initial Assessment",
    "patientLabel": "Patient",
    "ageLabel": "Age",
    "dateOfBirthLabel": "Date of Birth",
    "infantAssessment": "Infant Assessment",
    "loadingAssessment": "Loading infant assessment...",
    "assessmentTitle": "Infant Assessment (0-12 months)",
    "assessmentDescription": "Comprehensive screening for infants. Please complete all sections to help us provide the best care.",
    "completeAndContinue": "Complete Infant Assessment & Continue",
    "sectionsComplete": "{{completed}} of {{total}} sections complete",
    "monthsOld": "{{count}} months old",
    "oneMonthOld": "1 month old",
    "infantLabel": "infant",
    "na": "N/A",
    "pronouns": {
      "heMale": "he",
      "hisMale": "his",
      "himMale": "him",
      "HeMale": "He",
      "HisMale": "His",
      "heFemale": "she",
      "hisFemale": "her",
      "himFemale": "her",
      "HeFemale": "She",
      "HisFemale": "Her",
      "heNeutral": "they",
      "hisNeutral": "their",
      "himNeutral": "them",
      "HeNeutral": "They",
      "HisNeutral": "Their"
    },
    "greeting": {
      "dearGuardianWithRel": "Dear {{name}} ({{relationship}} of {{child}}),",
      "dearGuardian": "Dear {{name}},",
      "dearParents": "Dear Parents,",
      "intro": "Thank you for bringing {{child}} in for {{visitType}}. We know that caring for a baby can bring many questions and concerns, and we want you to know that we are here to support you. Below is a summary of what we found today and our recommendations for {{child}}'s care.",
      "followUp": "follow-up",
      "assessment": "assessment"
    },
    "findings": {
      "title": "What We Found Today",
      "howDoesItHappen": "How does this happen?",
      "whatCanBeDone": "What can be done?",
      "noConcerns": "We did not identify any specific concerns during today's assessment. {{child}} appears to be developing well. We have provided some general guidance below to support {{possessive}} ongoing development.",
      "yourConcerns": "Your Concerns",
      "concernsIntro": "You mentioned the following concerns: {{concerns}}. We have taken these into account in our assessment and recommendations below."
    },
    "tummyTime": {
      "title": "Tummy Time Programme",
      "forChild": "For {{child}} ({{age}}): {{minutes}}, {{frequency}}",
      "importance": "Tummy time is the single most important activity for your baby's physical development. It strengthens the neck, shoulders, and core muscles needed for rolling, sitting, and crawling.",
      "minutes1": "3–5 minutes",
      "frequency1": "2–3 times per day",
      "tip1_1": "Start with tummy time on your chest while you are reclined",
      "tip1_2": "Place baby on a firm surface with a small rolled towel under their chest",
      "tip1_3": "Stay close and talk or sing to keep baby engaged",
      "tip1_4": "Stop if baby becomes distressed and try again later",
      "minutes2": "10–15 minutes",
      "frequency2": "3–4 times per day",
      "tip2_1": "Use a play mat with colourful toys at eye level",
      "tip2_2": "Place a small mirror in front of baby to encourage head lifting",
      "tip2_3": "Try tummy time across your lap for variety",
      "tip2_4": "Support baby on a rolled-up towel or nursing pillow under their chest",
      "minutes3": "20–30 minutes",
      "frequency3": "4–5 times per day",
      "tip3_1": "Place toys in a semicircle to encourage reaching and turning",
      "tip3_2": "Allow baby to play on their tummy during floor time",
      "tip3_3": "Try propping on forearms to build upper body strength",
      "tip3_4": "Encourage rolling by placing toys just out of reach to one side",
      "minutes4": "30+ minutes",
      "frequency4": "Throughout the day during play",
      "tip4_1": "Let baby explore freely on the floor in a safe area",
      "tip4_2": "Encourage crawling by placing toys at a distance",
      "tip4_3": "Support pulling to stand and cruising along furniture",
      "tip4_4": "Continue floor-based play as the main activity"
    },
    "headShape": {
      "title": "Head Shape Advice",
      "alternateCot": "Alternate the direction {{child}} faces in the cot each night",
      "encourageLook": "Encourage {{child}} to look towards the non-flat side during play",
      "minimiseFlat": "Minimise time on flat surfaces. Use a sling or carry {{child}} upright",
      "continueTummy": "Continue supervised tummy time as the best treatment for flat spots",
      "noSleepChange": "Do NOT change sleep position. Always place {{child}} on {{possessive}} back to sleep",
      "reassurance": "Most positional head shape changes improve significantly as your baby gains head control and spends less time lying down."
    },
    "feeding": {
      "title": "Feeding Guidance",
      "sidePreference": "{{child}} prefers feeding from one side. Try alternating sides at each feed to encourage equal neck movement. If {{pronoun}} resists, try a different feeding position (e.g., football hold) on the less-preferred side.",
      "difficultyLatching": "Latching difficulty noted. Consider consulting a lactation specialist if this persists.",
      "fussesDuringFeeds": "{{child}} fusses during feeds. This may be related to reflux or discomfort. Try smaller, more frequent feeds.",
      "archesBack": "Back arching during feeds can indicate reflux. Keep {{child}} more upright during and after feeds.",
      "fallsAsleep": "If {{child}} falls asleep quickly during feeds, try gentle stimulation (tickle feet, cool cloth) to encourage longer feeds.",
      "spitsUp": "Frequent spitting up is common in babies. Keep {{child}} upright for 20–30 minutes after feeds.",
      "refluxTitle": "Reflux Management Tips:",
      "reflux1": "Keep upright for 20–30 minutes after each feed",
      "reflux2": "Offer smaller, more frequent feeds",
      "reflux3": "Wind gently during and after feeds",
      "reflux4": "Slightly elevate the head end of the cot"
    },
    "carrying": {
      "title": "Carrying & Holding Advice",
      "hipHealthy": "Hip-Healthy Carrying",
      "hipHealthyDesc": "Carry {{child}} with {{possessive}} legs straddling your hip in a frog-like position. Use a wide-based carrier that supports the thighs from knee to knee.",
      "varyPositions": "Vary Positions",
      "varyPositionsDesc": "Alternate which arm you carry {{child}} with. Try facing outward to encourage {{child}} to look around and strengthen neck muscles.",
      "forTorticollis": "For Torticollis",
      "torticollisDesc": "Carry {{child}} so {{pronoun}} has to turn {{possessive}} head towards the tight side to see you. When {{child}} is in your arms, position {{objective}} so interesting things are on {{possessive}} less-preferred side.",
      "forHipDysplasia": "For Hip Dysplasia",
      "hipDysplasiaDesc": "Always carry {{child}} with legs spread around you (straddle position). Avoid narrow carriers that force the legs together. When swaddling, allow {{possessive}} legs to be in a natural frog-like position."
    },
    "milestones": {
      "title": "Milestone Expectations",
      "disclaimer": "Every baby develops at their own pace. The milestones above are general guidelines. If you have concerns about {{child}}'s development, please discuss them with us or your health visitor.",
      "notCompleted": "Milestone tracking was not completed during this assessment. Please discuss any developmental concerns with your health visitor or GP."
    },
    "carePlan": {
      "title": "{{child}}'s Care Plan",
      "phase": "Phase",
      "frequencyLabel": "Frequency:",
      "durationLabel": "Duration:",
      "goals": "Goals",
      "techniques": "Techniques",
      "visitFrequency": "Visit Frequency:"
    },
    "homeAdvice": {
      "title": "Home Advice",
      "do": "Do",
      "avoid": "Avoid"
    },
    "redFlags": {
      "title": "When to Contact Us or See Your GP",
      "urgentTitle": "Seek urgent medical attention if {{child}}:",
      "temperature": "Has a temperature above 38°C (under 3 months) or 39°C (over 3 months)",
      "floppy": "Is unusually floppy, drowsy, or unresponsive",
      "vomiting": "Has projectile vomiting or vomit containing green bile",
      "refusesFeeds": "Refuses all feeds for more than 4–6 hours",
      "fontanelle": "Has a bulging fontanelle (soft spot)",
      "seizure": "Has a seizure or unusual movements",
      "soonerTitle": "Book a sooner appointment if:",
      "notImproving": "{{child}}'s condition does not seem to be improving",
      "newSymptoms": "New symptoms develop that concern you",
      "changeMovement": "You notice a change in {{possessive}} movement or behaviour",
      "questionsWorries": "You have any questions or worries between visits"
    },
    "parentNote": {
      "title": "A Note for Parents",
      "bodyWithConditions": "We understand that having a baby assessed can be an anxious experience. Please know that {{child}}'s condition is very common and responds well to the care and advice we have outlined. Babies are remarkably adaptable, and with your love and the right guidance, most musculoskeletal concerns in infancy resolve beautifully. You are doing a great job as parents.",
      "bodyNoConditions": "We understand that having a baby assessed can be an anxious experience. Please know that {{child}}'s development looks healthy and we are here to support you with any questions. Babies are remarkably adaptable, and with your love and the right guidance, most musculoskeletal concerns in infancy resolve beautifully. You are doing a great job as parents.",
      "contactUs": "If you ever have questions between appointments, please do not hesitate to contact us. No question is too small or silly. We would always rather you ask than worry."
    },
    "nextSteps": {
      "title": "Next Steps",
      "withFrequency": "We recommend seeing {{child}} again {{frequency}}.",
      "withoutFrequency": "We will schedule {{child}}'s next visit based on {{possessive}} progress.",
      "bookingIntro": "To book your next appointment or if you have any questions, please contact us:",
      "scanToBook": "Scan to book"
    }
  },
  "exerciseProgram": {
    "title": "Exercise Program",
    "homeTitle": "Home Exercise Program",
    "generated": "Generated",
    "noProgram": "No exercise program generated yet. Click \"Generate Exercise Plan\" to create a personalized program.",
    "generatePlan": "Generate Exercise Plan",
    "regenerate": "Regenerate",
    "generating": "Generating...",
    "downloading": "Downloading...",
    "downloadPdf": "Download PDF",
    "generateFailed": "Failed to generate exercise program",
    "pdfFailed": "Failed to generate exercise PDF",
    "pdfDownloadFailed": "PDF download failed",
    "contraindicationWarnings": "Contraindication Warnings",
    "sets": "Sets",
    "reps": "Reps",
    "hold": "Hold",
    "instructions": "Instructions",
    "guidedExercise": "Guided Exercise",
    "completed": "Completed",
    "guidedResults": "Guided Exercise Results",
    "totalExercises": "Total exercises",
    "regions": "Regions"
  },
  "consent": {
    "title": "Consent Management",
    "loadingConsents": "Loading consents...",
    "noData": "No consent data available.",
    "viewHistory": "View History",
    "hideHistory": "Hide History",
    "viewText": "View Text",
    "hideText": "Hide Text",
    "signConsent": "Sign Consent",
    "signing": "Signing...",
    "revoke": "Revoke",
    "revoking": "Revoking...",
    "signed": "Signed",
    "revoked": "Revoked",
    "consentText": "Consent Text",
    "history": "Consent History",
    "noHistory": "No history entries.",
    "actionSigned": "signed",
    "actionRevoked": "revoked",
    "by": "by",
    "status": {
      "active": "Active",
      "not_signed": "Not Signed",
      "revoked": "Revoked"
    }
  },
  "imaging": {
    "title": "Imaging Upload",
    "dismiss": "Dismiss",
    "dragDrop": "Drag and drop files here, or",
    "browseFiles": "browse files",
    "acceptedFormats": "JPEG, PNG, PDF up to 10MB each",
    "uploading": "Uploading...",
    "uploadedFiles": "Uploaded Files",
    "uploaded": "Uploaded",
    "analyzeWithAI": "Analyze with AI",
    "analyzing": "AI is analyzing...",
    "aiAnalysisResults": "AI Analysis Results",
    "aiAssistedObservation": "AI-assisted observation. Clinician verification required",
    "analyzed": "Analyzed",
    "findingsNotConfirmed": "Findings below are not confirmed until you verify each one",
    "findings": "Imaging Findings",
    "measurements": "Measurements",
    "impressions": "Impressions",
    "normal": "Normal",
    "reject": "Reject",
    "review": "Imaging Review",
    "comparison": "Imaging Comparison",
    "overallChange": "Overall change",
    "improved": "Improved",
    "stable": "Stable",
    "progressed": "Progressed",
    "aiAssisted": "AI-assisted analysis, reviewed and approved by clinician",
    "analyzeButton": "Analyse with AI",
    "uploadImage": "Upload Image",
    "compareButton": "Compare Images",
    "dateTaken": "Date Taken",
    "viewSequence": "View / Sequence"
  },
  "labResults": {
    "title": "Lab Results",
    "valuePlaceholder": "Value",
    "normal": "Normal",
    "autoInterpretation": "Auto-Interpretation",
    "savedSuccessfully": "Saved successfully",
    "saveResults": "Save Results"
  },
  "copilot": {
    "aggravating": "Aggravating",
    "analyze": "Analyze with AI",
    "analyzing": "Analyzing narrative...",
    "carePhase": "Recommended Care Phase",
    "clarification": "AI needs clarification",
    "close": "Close",
    "complaints": "Complaints",
    "confidence": "confidence",
    "diagnoses": "Diagnoses",
    "expected": "Expected",
    "followUp": "Follow-up",
    "functionalChanges": "Functional Changes",
    "initial": "Initial",
    "initialExam": "Initial Exam",
    "language": "Language",
    "listening": "Listening...",
    "loadingTests": "Getting test recommendations...",
    "newComplaints": "New Complaints",
    "painComparison": "Pain Comparison",
    "parsedFindings": "AI-Parsed Findings",
    "planUpdates": "Plan Updates",
    "previousNarrative": "Previous narrative:",
    "proceedToTests": "Proceed to Physical Exam Tests →",
    "progressSummary": "Progress Summary",
    "reExamComplete": "Re-Examination Complete",
    "reExamSaved": "All data has been saved to the patient record.",
    "redFlags": "Red Flags Identified",
    "relieving": "Relieving",
    "resolved": "Resolved",
    "saveComplete": "Save & Complete Re-Exam",
    "saving": "Saving re-exam...",
    "startReExam": "Start AI Re-Exam",
    "startVoice": "Start voice input",
    "starting": "Starting...",
    "stop": "Stop",
    "stopVoice": "Stop",
    "submitClarification": "Submit & Re-analyze",
    "submitResults": "Submit Results & Update DDx",
    "subtitle": "Re-examination",
    "testRationale": "Why these tests?",
    "testResults": "Test Results",
    "tests": "tests",
    "title": "AI Clinical Co-Pilot",
    "typeAnswer": "Type your answer...",
    "updatedDiagnoses": "Updated Diagnoses",
    "updatingDdx": "Updating diagnosis...",
    "voiceNotSupported": "Voice input not available in this browser. Please type your notes.",
    "wellnessScores": "Body Performance Scores"
  },
  "email": {
    "attachPdf": "Attach PDF report",
    "cancel": "Cancel",
    "language": "Report Language",
    "patientEmail": "Patient Email",
    "send": "Send Email",
    "sendReport": "Send Report Email",
    "sending": "Sending...",
    "templatePreview": "Email Template Preview"
  },
  "exercises": {
    "title": "Exercise Plan",
    "current": "Current Exercises",
    "history": "Exercise History",
    "addExercise": "Add Exercise",
    "recommended": "Recommended",
    "progress": "Progress",
    "pause": "Pause",
    "resume": "Resume",
    "remove": "Remove",
    "logSession": "Log Session",
    "logAll": "Log All",
    "printSheet": "Print Exercise Sheet",
    "adherence": "Adherence",
    "excellent": "Excellent",
    "good": "Good",
    "needsImprovement": "Needs Improvement",
    "atRisk": "At Risk",
    "setsCompleted": "Sets Completed",
    "repsCompleted": "Reps Completed",
    "painDuring": "Pain During",
    "painAfter": "Pain After",
    "difficulty": "Difficulty",
    "tooEasy": "Too Easy",
    "justRight": "Just Right",
    "tooHard": "Too Hard",
    "level1": "Beginner",
    "level2": "Intermediate",
    "level3": "Advanced",
    "level4": "Athletic",
    "level5": "Elite",
    "activeCare": "Active Care",
    "correctiveCare": "Rehabilitation",
    "maintenance": "Maintenance",
    "myObligations": "My Body My Obligations",
    "allDoneToday": "All done for today!",
    "keepGoing": "Keep going!",
    "greatConsistency": "Great consistency!",
    "sets": "Sets",
    "reps": "Reps",
    "hold": "Hold",
    "rest": "Rest",
    "frequency": "Frequency",
    "perWeek": "per week",
    "equipment": "Equipment",
    "formCheckpoints": "Form Checkpoints",
    "contraindications": "Contraindications",
    "progressionCriteria": "Progression Criteria",
    "prescribedDate": "Prescribed",
    "expiresDate": "Expires",
    "supersededBy": "Superseded by",
    "noExercises": "No exercises prescribed yet",
    "addFromLibrary": "Add from Library",
    "confirmRemove": "Remove this exercise from the plan?",
    "progressTo": "Progress to next level",
    "exerciseLibrary": "Exercise Library",
    "filterByRegion": "Filter by region",
    "filterByLevel": "Filter by level",
    "filterByCategory": "Filter by category",
    "addToPlan": "Add to Plan",
    "phase": "Phase",
    "notes": "Notes",
    "allLevels": "All Levels",
    "allCategories": "All Categories",
    "allRegions": "All Regions",
    "xTimesPerWeek": "{{count}}x per week",
    "painScale": "Pain (0-10)",
    "streakDays": "day streak",
    "loggedToday": "Logged today",
    "noData": "No data",
    "thisWeek": "this week",
    "none": "No exercises prescribed yet.",
    "doWithCamera": "Do with Camera",
    "markDone": "Done",
    "start": "Start",
    "cancel": "Cancel",
    "finish": "Finish",
    "setDone": "Set Complete",
    "nextSet": "Next set in",
    "formScore": "Form Quality",
    "allDone": "All Done!",
    "voice": {
      "begin": "Begin your exercise now"
    },
    "feedback": {
      "great": "Great form!",
      "good": "Good, try to go a bit deeper",
      "watch": "Watch your form. Focus on full range",
      "excellent": "Excellent!"
    }
  },
  "funcMovement": {
    "accept": "Accept",
    "aiSummary": "AI Clinical Summary",
    "analyzing": "Analyzing movement...",
    "back": "Back to tests",
    "categoryBreakdown": "Category Breakdown",
    "generateReport": "Generate Report",
    "overallScore": "Overall Functional Movement Score",
    "patientReady": "Patient Ready",
    "quickScreen": "Quick Screen (~3 min)",
    "readToPatient": "Read to patient:",
    "recommendations": "Recommendations",
    "redo": "Redo",
    "result": "Result",
    "setupInstructions": "Position the device on a stable surface, 2 meters from the patient",
    "skip": "Skip",
    "startTest": "Start Test",
    "stopCapture": "Stop",
    "title": "Functional Movement Assessment"
  },
  "gamification": {
    "achievements": "Achievements",
    "balance": "Balance",
    "best": "Best",
    "bodyPerformance": "Body Performance Score",
    "change": "Change",
    "completedExercises": "Completed home exercises",
    "converted": "Joined",
    "copied": "Copied! Share with friends",
    "current": "Current",
    "dailyCheckIn": "Daily Check-In",
    "dayStreak": "day streak",
    "days": "days",
    "energyLevel": "Energy level",
    "howDidYouMove": "How did you move today?",
    "initial": "Initial",
    "lifestyle": "Lifestyle",
    "movement": "Movement",
    "nextTier": "Next",
    "noAchievementsInCategory": "No achievements in this category",
    "noStreaks": "Start your first streak today!",
    "nowScore": "Now",
    "pending": "Pending",
    "personalBest": "Personal Best!",
    "progressSnapshot": "Your Progress",
    "recovery": "Recovery",
    "referralMessage": "I recommend",
    "referralProgram": "Referral Program",
    "referralUseCode": "Use my referral code",
    "retry": "Retry",
    "shareCode": "Copy & Share Code",
    "sleepQuality": "Sleep quality",
    "sortCategory": "Sort by category",
    "sortRecent": "Sort by recent",
    "startScore": "Start",
    "streaks": "Your Streaks",
    "strength": "Strength",
    "stressLevel": "Stress level (1=low, 5=high)",
    "submitCheckIn": "Submit Check-In",
    "submitting": "Submitting...",
    "total": "Total",
    "visits": "visits",
    "yourCode": "Your referral code"
  },
  "lifestyle": {
    "activity": "Physical Activity",
    "alcohol": "Alcohol consumption?",
    "answered": "answered",
    "breaks": "Regular breaks?",
    "diet": "Describe your diet?",
    "ergonomics": "Work & Ergonomics",
    "exerciseFreq": "How often do you exercise?",
    "exerciseTypes": "What type?",
    "habits": "Habits",
    "howActive": "How active are you?",
    "nutrition": "Nutrition & Hydration",
    "occupation": "Daily activity level?",
    "quickMode": "← Quick mode",
    "quickTitle": "Quick Lifestyle Check",
    "saving": "Saving...",
    "sitting": "Hours sitting per day?",
    "sittingQ": "Hours sitting daily?",
    "sleep": "Sleep",
    "sleepHours": "Hours per night?",
    "sleepQ": "Sleep quality?",
    "sleepQuality": "Sleep quality?",
    "smoking": "Do you smoke?",
    "stress": "Stress",
    "stressLevel": "Stress level?",
    "stressQ": "Stress level?",
    "stressSources": "Main sources?",
    "title": "Lifestyle Score",
    "wantMore": "Want more detail? Expand full assessment →",
    "water": "Glasses of water per day?"
  },
  "notifications": {
    "empty": "No notifications",
    "markAllRead": "Mark all read",
    "title": "Notifications"
  },
  "painMap": {
    "back": "Back",
    "clearView": "Clear this view",
    "front": "Front",
    "instruction": "Tap on the body to mark pain locations",
    "markers": "markers",
    "title": "Mark Pain Location",
    "undo": "Undo last"
  },
  "planner": {
    "headers": {
      "phase": "Phase",
      "frequency": "Frequency",
      "duration": "Duration (weeks)",
      "action": "Action"
    },
    "totalVisits": "Total visits before maintenance: {{count}}"
  },
  "portal": {
    "achievements": "Your Achievements",
    "balance": "Balance",
    "bodyPerformance": "Your Body Performance",
    "breakdown": "Score Breakdown",
    "calmToStressed": "Calm → Stressed",
    "checkedIn": "Checked in today!",
    "codeHint": "Check your report or ask reception",
    "copied": "Copied!",
    "copyShare": "Copy & Share Code",
    "dailyQuote": "Every step forward is a step toward a stronger you.",
    "dayStreak": "day streak",
    "didExercises": "Did you do your exercises?",
    "doneToday": "done today",
    "download": "Download",
    "earned": "earned",
    "energyLevel": "Energy level?",
    "enterCode": "Enter your access code to view your health dashboard",
    "estimatedNext": "Estimated next visit",
    "exercises": "Exercises",
    "faq": "Frequently Asked Questions",
    "faqAfterPain": "What happens after my pain is gone?",
    "faqAfterPainA": "You will move on to Wellness Care: regular check-ups that keep you performing at your best. Think of it like a service for your body!",
    "faqFreqActive": "During Relief Care, we recommend 2 visits per week for optimal results.",
    "faqFreqMaint": "At your current phase, monthly check-ups are sufficient.",
    "faqFrequency": "How often should I come?",
    "faqScoring": "How does the scoring work?",
    "faqScoringA": "Your Body Performance Score measures 5 areas: Movement, Strength, Balance, Recovery, and Lifestyle. Each area is scored 0-100, and your overall score is a weighted average.",
    "faqWhenBetter": "When will I feel better?",
    "faqWhenBetterA": "Most patients notice improvement within 2-4 weeks. Your body is unique, and we will track your progress together.",
    "firstVisit": "First Visit",
    "friendsJoined": "Friends joined",
    "health": "Health",
    "howFeeling": "How are you feeling today?",
    "howMove": "How did you move today?",
    "invalidCode": "Invalid code. Please check and try again.",
    "journeyTimeline": "Your Journey",
    "lifestyle": "Lifestyle",
    "movement": "Movement",
    "myExercises": "My Exercises",
    "myReports": "My Reports",
    "needHelp": "Need help? Contact your clinic",
    "networkError": "Connection error. Please try again.",
    "next": "Next",
    "nextVisit": "Next visit",
    "no": "No",
    "noAchievementsYet": "Complete check-ins to earn badges!",
    "noExercises": "No exercises prescribed yet.",
    "noProgress": "Complete at least 2 assessments to see your progress.",
    "noReferral": "Ask your clinic for a referral code.",
    "noReports": "No reports available yet.",
    "now": "Now",
    "personalBest": "New Personal Best!",
    "personalizedTips": "Your Improvement Plan",
    "pointsImproved": "points improved",
    "recovery": "Recovery",
    "refer": "Refer",
    "referralMsg": "I recommend",
    "reports": "Reports",
    "seeFullProgress": "See full progress →",
    "shareWellness": "Share the Wellness Journey!",
    "sinceLast": "since last visit",
    "sleepQuality": "How did you sleep?",
    "startStreak": "Start your streak today!",
    "strength": "Strength",
    "stressLevel": "Stress level?",
    "totalShares": "Total shares",
    "treatmentGoals": "Your Goals",
    "useCode": "Use code",
    "verifying": "Verifying...",
    "viewAll": "View all →",
    "viewCarePlan": "View your full care plan →",
    "viewDashboard": "View My Dashboard",
    "welcome": "Welcome",
    "yes": "Yes",
    "yourCarePlan": "Your Care Plan",
    "yourJourney": "Your Health Journey",
    "yourProgress": "Your Progress",
    "yourReferralCode": "Your referral code",
    "hiName": "Hi {{name}}!",
    "stageRelief": "Relief Care",
    "stageRehab": "Rehabilitation",
    "stageWellness": "Wellness Care"
  },
  "portalAdmin": {
    "accessCode": "Access Code",
    "generate": "Generate Access Code",
    "generating": "Generating...",
    "noAccess": "No portal access set up yet",
    "patientPortal": "Patient Portal Access"
  },
  "save": {
    "ago": "ago",
    "justNow": "Just now",
    "saveDraft": "Save Draft",
    "saveExit": "Save & Exit",
    "saved": "Saved",
    "saving": "Saving...",
    "unsaved": "Unsaved changes",
    "upToDate": "Up to date"
  },
  "screening": {
    "alerts": "Clinical Screening Alerts",
    "bpHeadache": "BP measurement recommended for headache presentation.",
    "bpRecommended": "Blood Pressure Check Recommended",
    "cnHeadache": "Patient presents with headache. CN assessment recommended.",
    "cnNeuro": "Neurological Screening Recommended",
    "cnNeuroReason": "Cervical complaint with neurological symptoms.",
    "cnRecommended": "Cranial Nerve Examination Recommended",
    "save": "Save",
    "saveResults": "Save CN Results",
    "vbiReason": "Cervical complaint with dizziness. VBI screening required before manipulation.",
    "vbiRequired": "Vertebral Artery Screening Required"
  },
  "softTissue": {
    "confirmWith": "Confirm with",
    "more": "more available",
    "noStructures": "No structures loaded for selected regions. Structures will appear once data is available.",
    "palpation": "Palpation Guide",
    "showLess": "← Show top 3 only",
    "significance": "Clinical Significance",
    "title": "Soft Tissue Assessment",
    "top3": "Top 3 relevant"
  },
  "uploads": {
    "addToFile": "Add to Your Health File",
    "description": "Description (optional)",
    "logToday": "Log Today",
    "myUploads": "My Uploads",
    "trackBody": "Track Your Body",
    "upload": "Upload",
    "uploading": "Uploading..."
  },
  "intake": {
    "loading": "Loading...",
    "oops": "Oops",
    "noToken": "No token provided.",
    "linkExpired": "This link has expired. Please contact the clinic for a new one.",
    "invalidLink": "Invalid link. Please contact the clinic.",
    "somethingWrong": "Something went wrong.",
    "unableToConnect": "Unable to connect. Please check your internet and try again."
  },
  "onboarding": {
    "stepOf": "Step {{current}} of {{total}}",
    "finishLater": "I'll finish later",
    "back": "Back",
    "next": "Next",
    "completeSetup": "Complete Setup",
    "welcome": {
      "title": "Welcome to MSK Insight",
      "subtitle": "Let's set up your clinic in about 5 minutes. You can change everything later in Settings.",
      "clinicTypePrompt": "What type of clinic are you?",
      "getStarted": "Get Started"
    },
    "clinicIdentity": {
      "title": "Clinic Identity",
      "subtitle": "Basic information about your clinic.",
      "clinicName": "Clinic Name",
      "phone": "Phone",
      "email": "Email",
      "address": "Address",
      "whatsapp": "WhatsApp",
      "website": "Website",
      "placeholderName": "e.g. The Chiropractic Center",
      "placeholderPhone": "+357 25 344747",
      "placeholderEmail": "info@yourclinic.com",
      "placeholderAddress": "25 Makarios Avenue, 3040 Limassol, Cyprus",
      "placeholderWhatsapp": "+357 99 123456",
      "placeholderWebsite": "https://yourclinic.com",
      "errorClinicName": "Clinic name is required",
      "errorPhone": "Phone number is required",
      "errorEmail": "Email is required"
    },
    "team": {
      "title": "Your Team",
      "subtitle": "Who works at your clinic? You can add more team members later.",
      "lead": "Lead",
      "fullName": "Full Name",
      "roleTitle": "Role / Title",
      "credential": "Professional Credential",
      "bio": "Short Bio",
      "bioPlaceholder": "Brief professional bio (optional)",
      "leadOwner": "Lead / Owner Clinician",
      "add": "Add",
      "save": "Save",
      "cancel": "Cancel",
      "addTeamMember": "+ Add Team Member",
      "select": "-- Select --",
      "placeholderName": "e.g. Maria Georgiou",
      "placeholderTitle": "e.g. Lead Chiropractor"
    },
    "modalities": {
      "title": "Clinical Modalities",
      "subtitle": "What treatments does your clinic offer? AI recommendations will be limited to these."
    },
    "assessmentTools": {
      "title": "Assessment Tools",
      "subtitle": "What diagnostic tools do you use? You can skip this step."
    },
    "carePathway": {
      "title": "Care Pathway",
      "subtitle": "How do you structure patient care? These are pre-filled based on your clinic type."
    },
    "reportPreferences": {
      "title": "Report Preferences",
      "subtitle": "How should your patient reports and GP letters look?"
    },
    "integrations": {
      "title": "Integrations",
      "subtitle": "Connect your existing tools. You can set these up later in Settings.",
      "practiceHub": "PracticeHub",
      "practiceHubDesc": "Sync appointments and patient data",
      "emailSmtp": "Email (SMTP)",
      "emailSmtpDesc": "Send patient reports and reminders",
      "aiAssistant": "AI Assistant",
      "aiAssistantDesc": "AI-powered report narratives and clinical insights",
      "configureAfter": "Configure in Settings → Integrations after setup.",
      "allOptional": "All integrations are optional and can be configured anytime from the Settings page."
    },
    "review": {
      "title": "Review Your Setup",
      "subtitle": "Everything looks good? You can change any of this later in Settings.",
      "clinicIdentity": "Clinic Identity",
      "yourTeam": "Your Team",
      "clinicalModalities": "Clinical Modalities",
      "assessmentTools": "Assessment Tools",
      "carePathway": "Care Pathway",
      "reportPreferences": "Report Preferences",
      "clinicType": "Clinic Type",
      "edit": "Edit",
      "notConfigured": "Not configured yet",
      "name": "Name",
      "phone": "Phone",
      "email": "Email",
      "address": "Address",
      "languages": "Languages",
      "notSet": "Not set"
    },
    "completion": {
      "title": "Your clinic is ready!",
      "subtitle": "Everything is set up. You can start seeing patients right away, or customise further in Settings.",
      "addFirstPatient": "Add Your First Patient",
      "exploreDashboard": "Explore the Dashboard",
      "customiseSettings": "Customise Settings",
      "redirecting": "Redirecting to dashboard in {{seconds}} seconds..."
    }
  },
  "session": {
    "warning": {
      "message": "Your session will expire in 5 minutes. Click to stay logged in.",
      "button": "Stay logged in"
    },
    "expired": {
      "toast": "Your session expired. Please log in again."
    }
  },
  "reportV2": {
    "rv2CoverTitle": "Your Personal Recovery & Performance Plan",
    "rv2PreparedFor": "Prepared for **{patient_full_name}** · {report_date}",
    "rv2ToldLabel": "What you told us",
    "rv2GoalsLabel": "What you want back",
    "rv2WhatItMeansLabel": "What it means:",
    "rv2ContributingLabel": "Contributing areas:",
    "rv2HowWeCanHelpLabel": "How we can help",
    "rv2AlsoCovered": "Also covered by your plan",
    "rv2RecoveryDialTitle": "Your Recovery Score",
    "rv2ProgressHeading": "Your Progress Since Last Visit",
    "rv2ScheduleHeading": "Your treatment schedule",
    "rv2ScheduleFootnote": "Treatment protocols reviewed against latest clinical evidence.",
    "rv2BookingDatesNote": "Your actual booking dates may differ slightly depending on diary availability.",
    "rv2Ongoing": "Ongoing",
    "rv2CarePlanHeading": "Your Personalised Care Plan",
    "rv2HomeAdviceHeading": "Your Home Care Plan",
    "rv2ColDoNow": "Do Now",
    "rv2ColAvoid": "Things to Avoid",
    "rv2ColLifestyle": "Lifestyle Changes",
    "rv2ColSupplement": "Supplement",
    "rv2ColDosage": "Dosage",
    "rv2ColWhen": "When to Take",
    "rv2ColWhatItDoes": "What It Does",
    "rv2AsDirected": "As directed",
    "rv2SupportsRecovery": "Supports recovery and wellness",
    "rv2Daily": "Daily",
    "rv2QrCaption": "Scan to book online",
    "rv2ContentsStory": "Your story",
    "rv2ContentsFound": "What we found",
    "rv2ContentsCarePlan": "Your care plan",
    "rv2ContentsNext": "Next steps",
    "rv2Call": "Call",
    "rv2Online": "Online",
    "rv2Page": "Page",
    "rv2PainRatingLabel": "your pain rating",
    "rv2NotRecorded": "Not recorded this visit",
    "rv2OpeningHours": "Opening Hours:",
    "rv2GoalsTarget": "That's our shared target, the plan below is built to get you there.",
    "rv2HowWeCanHelpText": "care that aims to calm the irritated tissue, restore the movement and strength that protect it, and help you stay well long-term.",
    "rv2GoldenIntro": "These are the key things to remember between appointments. Following these guidelines will help you get the best results from your treatment.",
    "rv2ExerciseNote": "Any exercises shown or discussed are examples only. Your rehabilitation specialist will prescribe the exercises that are right for you at the right stage of your care.",
    "rv2TroublingFor": "troubling you for",
    "rv2ByYourChiropractor": "By your chiropractor {name} ({credential})",
    "rv2WhyLabel": "Why we do this",
    "rv2WhyText": "At The Chiropractic Center we have built a technology-empowered, people-driven, multidisciplinary team with one job: to help you and to empower you to reach your goals. We look for the real cause, we rebuild what your body needs, and we hand you back ownership of your health. And when you are ready for more than recovery, lifelong care and wellness are waiting. Always your choice, always your pace.",
    "rv2JourneyCaption": "calm it · rebuild it · keep it for life",
    "rv2JourneyChoice": "The third stage is an invitation. Always your choice.",
    "rv2WhatItMeansFallback": "The structures in that area are irritated and lack adequate support, which a focused, staged plan is well suited to address",
    "rv2PageOf": "of"
  },
  "versionNudge": {
    "message": "A new version is available",
    "reload": "Reload",
    "later": "Later"
  },
  "autosave": {
    "finalizedNothingToSave": "This assessment is finalized. There is nothing left to save.",
    "finalizedShort": "Finalized"
  },
  "reportGenerator": {
    "emailNotEnabled": "Email delivery is not yet enabled for this clinic. Ask your clinic admin to set it up.",
    "emailNeedsFinalize": "Finalize the assessment before emailing the report to the patient."
  },
  "amend": {
    "inProgressTitle": "Amendment in progress",
    "inProgressBody": "Version {{version}} stays live and unchanged until you press Complete, which publishes version {{next}}.",
    "button": "Amend report",
    "reopening": "Reopening...",
    "buttonHint": "Reopen this issued report to publish a corrected version",
    "currentVersion": "Current version: {{version}}",
    "failed": "Could not reopen this report for amendment."
  },
  "pushStatus": {
    "delivered": "Sent to PracticeHub v{{version}}",
    "retrying": "PracticeHub: retrying at {{time}}",
    "failed": "PracticeHub: not sent after {{attempts}} attempts",
    "pushNow": "Push now",
    "pushing": "Pushing…"
  },
  "lifecycle": {
    "draft": "Draft",
    "confirmedNotIssued": "Confirmed, not issued",
    "amending": "Amendment in progress",
    "issued": "Issued v{{version}}"
  },
  "sprint6": {
    "journeyWeekByWeek": "Week by week",
    "journeyWeekLabel": "Week {{n}}",
    "journeyAnd": "and",
    "journeyOr": "or",
    "journeyWith": "with",
    "journeyGapWeek": "no visit this week",
    "journeyChoiceNote": "If two names are shown, we'll decide who you'll see and confirm this when we book your visit.",
    "journeyThenMaintenance": "then Wellness Care every 6 weeks",
    "journeyPractitionerColumn": "Practitioner"
  },
  "letterMachine": {
    "title": "Generate Letter",
    "letterType": "Letter type",
    "typeReferral": "Referral",
    "typeProgress": "Progress",
    "typeInsurance": "Insurance",
    "recipient": "Recipient",
    "recipientHintReferral": "e.g. \"Dr Jane Smith\"",
    "recipientHintProgress": "e.g. \"Dr Jane Smith\" (or blank for the patient's records)",
    "recipientHintInsurance": "e.g. insurer name, or leave blank for \"To Whom It May Concern\"",
    "policyRef": "Policy / claim reference (optional)",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "generating": "Generating…",
    "editableDraft": "Editable draft",
    "editsNote": "Edits here are what get copied, downloaded, pushed and emailed.",
    "copy": "Copy",
    "copied": "Letter copied to clipboard",
    "copyFailed": "Copy failed. Select and copy manually",
    "downloadPdf": "Download PDF",
    "rendering": "Rendering…",
    "pushToPracticeHub": "Push to PracticeHub",
    "pushing": "Pushing…",
    "emailToPatient": "Email to patient",
    "sending": "Sending…",
    "englishOnly": "Letters are produced in English.",
    "requests": "Requests",
    "requestsIntro": "Tick what you are asking for. Suggested rows come from red flags and the working hypothesis; untick anything you do not want.",
    "addRequest": "Add request",
    "noRequests": "Nothing selected: the letter will be a clinical update only.",
    "loadingSuggestions": "Loading suggestions…",
    "kind": "Kind",
    "kindImaging": "Imaging",
    "kindOpinion": "Specialist opinion",
    "kindEmergency": "Emergency pathway",
    "kindUpdateOnly": "Clinical update only",
    "modality": "Modality",
    "specialty": "Specialty",
    "region": "Region",
    "purpose": "Purpose",
    "purposeCustom": "Other purpose (type your own)",
    "urgency": "Urgency",
    "urgencyRoutine": "Routine",
    "urgencySoon": "Soon",
    "urgencyUrgent": "Urgent",
    "urgencyEmergency": "Emergency",
    "suggested": "Suggested",
    "fromRedFlag": "from red flag",
    "fromHypothesis": "from working hypothesis",
    "remove": "Remove",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "regionNone": "No region"
  },
  "phV3": {
    "title": "PracticeHub v3 (new API)",
    "intro": "For the move to PracticeHub's new API. Not in use yet: every resource below stays on the legacy connection until the October check.",
    "keyLabel": "v3 API key (starts with phk_)",
    "keyPlaceholder": "phk_…",
    "fingerprint": "Key fingerprint: {{fp}}. Leave blank to keep",
    "save": "Save v3 key",
    "saving": "Saving…",
    "saved": "PracticeHub v3 key saved.",
    "accepted": "Saved. PracticeHub v3 accepted the key.",
    "readOnlyWarn": "This key can write. Create a read-only key for MSK Insight and save that instead.",
    "tzWarn": "The account timezone is {{tz}}. MSK Insight reads clinic times as Europe/Nicosia, so appointment reads through v3 will be refused until this is resolved.",
    "refused": "Saved, but PracticeHub refused it. Check that you copied the whole key.",
    "rateLimited": "Saved, but PracticeHub is limiting requests right now. It will be tested again on the next save.",
    "untested": "Saved, but PracticeHub could not be reached to test it.",
    "isLegacy": "This is a legacy PracticeHub API key. It belongs in the legacy key field above; this field takes only new-API keys that start with phk_. Nothing was stored.",
    "invalidShape": "That is not a PracticeHub v3 API key. Copy it again from PracticeHub → Developers → API Keys. Nothing was stored.",
    "notConfigured": "Save a PracticeHub v3 key before turning a resource over to v3.",
    "writeKeyLabel": "v3 write key (starts with phk_)",
    "writeKeyHint": "A second key, with write access, used ONLY to deliver reports. Reads and syncs never use it. Create it in PracticeHub → Developers → API Keys with Access level: Read and write.",
    "writeSave": "Save v3 write key",
    "writeSaved": "PracticeHub v3 write key saved.",
    "writeAccepted": "Saved. PracticeHub v3 accepted the key, and it can write.",
    "writeNoScope": "Saved, but this key cannot write. Create a key with Access level: Read and write for report delivery.",
    "writeUntested": "Saved, but PracticeHub could not be reached to test it.",
    "patientsNeedsMrn": "The patients switch stays off until PracticeHub confirms which v3 field holds your patient number (MRN). Until then, patients keep syncing through the legacy connection and every existing MRN is kept.",
    "patientsCheckFirst": "Turning patients on first checks 20 patients live: each must carry its patient number (MRN) in v3, equal to the number the legacy connection has.",
    "waitingForMigration": "Waiting for PracticeHub's migration: {{populated}} of {{checked}} patients checked carry a patient number in v3, and {{equal}} match the legacy number. The patients switch stays off, and every existing MRN is kept.",
    "mrnCheckFailed": "The patient-number check could not reach PracticeHub, so the patients switch stays off. Try again in a few minutes.",
    "saveFailed": "Could not save the PracticeHub v3 settings.",
    "switchesTitle": "Read from v3, per resource",
    "switchesHint": "All off until the October live check. A resource that is off reads from the legacy API, exactly as today.",
    "resource": {
      "patients": "Patients",
      "appointments": "Appointments",
      "practitioners": "Practitioners",
      "files": "Files",
      "clinical_notes": "Clinical notes"
    },
    "saveSwitches": "Save switches",
    "switchesSaved": "Switches saved.",
    "pushesLabel": "Send reports to PracticeHub through v3",
    "pushesHint": "Off: reports go through the legacy connection, as today. On: the note and the PDFs go through v3 with the write key, each carrying our reference so a lost reply is found again instead of being sent twice.",
    "pushesOn": "Reports now go to PracticeHub through v3.",
    "pushesOff": "Reports now go to PracticeHub through the legacy connection.",
    "pushesNeedWriteKey": "Save a v3 write key first."
  },
  "quickReportDetour": {
    "question": "Add a posture screen or imaging before continuing?",
    "hint": "You can add a PostureScreen report or imaging now; you will come back to the diagnosis afterwards.",
    "addPosture": "Add posture screen",
    "addImaging": "Add imaging",
    "no": "No, continue",
    "bannerText": "When you have added what you need, continue to the diagnosis.",
    "returnButton": "Continue to diagnosis"
  },
  "phFiles": {
    "title_one": "{{count}} file in PracticeHub",
    "title_other": "{{count}} files in PracticeHub",
    "none": "No files for this patient in PracticeHub.",
    "unnamed": "(no file name)",
    "listOnly": "Listed from PracticeHub; open them in PracticeHub.",
    "rateLimited": "PracticeHub files are temporarily unavailable. They will show again shortly."
  },
  "imagingStudy": {
    "title": "Imaging study",
    "imagesCount_one": "{{count}} image",
    "imagesCount_other": "{{count}} images",
    "status_uploaded": "Not read yet",
    "status_analysed": "Summary ready for review",
    "status_accepted": "Summary accepted",
    "analyse": "Read all {{count}} images together",
    "analysing": "Reading the study…",
    "accept": "Accept summary",
    "reviewLines": "Review lines",
    "hideLines": "Hide line review",
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "reject": "Reject",
    "rejected": "rejected",
    "edited": "edited",
    "series": "Series",
    "findings": "Findings",
    "measurements": "Measurements",
    "impressions": "Impressions",
    "pendingNote": "AI-assisted observation. Nothing here reaches the diagnosis or the report until you accept the summary.",
    "acceptedNote": "AI-assisted observation, summary accepted by the clinician. Accepted and edited lines inform the diagnosis and the report's investigations section.",
    "excluded_one": "{{count}} file could not be read by the AI (only JPEG, PNG or WebP images can be analysed).",
    "excluded_other": "{{count}} files could not be read by the AI (only JPEG, PNG or WebP images can be analysed).",
    "groupUnassigned": "Read the {{count}} earlier images together as one study",
    "regionMatch": "The imaged region matches the complaint region.",
    "regionMismatch": "The images show {{imaging}}, but the complaint region is {{complaint}}. Check the images belong to this complaint before accepting.",
    "regionUnknown": "The imaged region could not be read from the images; check it against the complaint region yourself.",
    "regionNoComplaint": "This assessment has no complaint region to compare the imaging with.",
    "failed": "That did not work: {{message}}",
    "region": {
      "cervical": "cervical spine",
      "thoracic": "thoracic spine",
      "lumbar": "lumbar spine",
      "sacral": "sacrum/pelvis",
      "shoulder": "shoulder",
      "elbow": "elbow",
      "wrist_hand": "wrist/hand",
      "hip": "hip",
      "knee": "knee",
      "ankle_foot": "ankle/foot",
      "tmj": "jaw (TMJ)"
    },
    "reportAttached": "+ radiologist's report",
    "radiologistReport": "Radiologist's report (verbatim)",
    "radFindings": "Radiologist's findings",
    "radImpression": "Radiologist's impression",
    "aiObservations": "AI image observations",
    "disagreeBanner": "The AI's observations disagree with the radiologist's report:",
    "radSays": "radiologist",
    "aiSays": "AI",
    "agreeNote": "The AI's observations agree with the radiologist's report.",
    "compareUnavailable": "The radiologist's report and the AI's observations could not be compared: {{note}}",
    "aiUnavailable": "AI image observations are unavailable ({{note}}). The radiologist's report leads on its own.",
    "reportUnrecognised": "A PDF was uploaded with the images, but no Findings or Impression section was found in it. Read the report itself."
  },
  "postureCapture": {
    "title": "Posture capture",
    "steps": "Posture capture steps",
    "step": {
      "setup": "Session",
      "photos": "Photos",
      "wall": "Wall readings",
      "mark": "Tap the dots",
      "summary": "Summary"
    },
    "script": "Stand the way you normally stand. Do not stand tall for the camera. Look straight ahead.",
    "kind": {
      "label": "Session kind",
      "normal": "Normal",
      "stand_tall": "Stand tall",
      "repeat_test": "Repeat test"
    },
    "week": {
      "label": "Week",
      "none": "No week",
      "w0": "Week 0",
      "w6": "Week 6",
      "w12": "Week 12"
    },
    "settings": {
      "cameraDistanceCm": "Camera distance (cm)",
      "lensHeightCm": "Lens height (cm)",
      "floorMark": "Floor mark used",
      "defaultsHint": "The defaults are the clinic's standard set-up. Change them only if the camera was placed differently today."
    },
    "createSession": "Create session",
    "creating": "Creating the session...",
    "sessionCreated": "Session created",
    "view": {
      "front": "Front",
      "back": "Back",
      "left": "Left side",
      "right": "Right side"
    },
    "photos": {
      "hint": "Up to {{max}} photos per view, JPEG or PNG. Each photo is uploaded as soon as it is chosen.",
      "takePhoto": "Take photo",
      "chooseFile": "Choose file",
      "limit": "This view already has {{max}} photos.",
      "uploading": "Uploading...",
      "uploaded": "Uploaded",
      "failed": "Upload refused",
      "refusedType": "Only JPEG or PNG photos are accepted.",
      "refusedSize": "The photo is larger than 15 MB.",
      "empty": "No photo yet",
      "thumbAlt": "{{view}} photo {{index}}"
    },
    "wall": {
      "title": "Head-to-wall readings",
      "hint": "Three readings in centimetres, taken with the person standing against the wall.",
      "reading": "Reading {{n}} (cm)",
      "save": "Save readings",
      "saved": "Readings saved",
      "invalid": "Enter three numbers of zero or more centimetres."
    },
    "mark": {
      "next": "Tap",
      "complete": "All dots placed",
      "undo": "Undo last dot",
      "redo": "Redo this view",
      "save": "Save dots",
      "saved": "Dots saved",
      "earlierHidden": "Earlier sessions' numbers are not shown while marking.",
      "noCaptures": "No photos yet. Add photos first.",
      "loadingImage": "Loading the photo...",
      "imageAlt": "{{view}} photo {{index}}, tap to place a dot"
    },
    "landmark": {
      "tragus": "Ear point (tragus)",
      "c7": "Base of the neck (C7)",
      "leftEar": "Left ear",
      "rightEar": "Right ear",
      "leftShoulder": "Left shoulder",
      "rightShoulder": "Right shoulder"
    },
    "summary": {
      "title": "Capture summary",
      "noVerdict": "Angles and the capture check only. No score, no result and no report on this screen.",
      "noneMarked": "No dots saved for this view.",
      "neckAngle": "Neck angle",
      "shoulderLine": "Shoulder line tilt",
      "headLine": "Head line tilt",
      "mean": "Mean",
      "spread": "spread",
      "needsRemark": "Re-mark needed: the photos disagree",
      "agree": "The photos agree",
      "settings": "Capture set-up check",
      "settingsOk": "The set-up is within the standard tolerances.",
      "nominal": "standard",
      "remark": "Re-mark the dots"
    },
    "next": "Next",
    "error": {
      "generic": "The server refused the request."
    }
  }
}
